/* pp-portal.js — Première Peau Partner Portal engine.
   Client-side wizard over Shopify's native contact form. No backend, no dependencies.
   State lives in localStorage; the gate is obscurity, not security. */

(function (w, d) {
  'use strict';

  var KEY = 'pp_partner_portal_v1';
  var PENDING = 'pp_partner_pending_v1';

  /* ------------------------------------------------------------------ utils */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fmt(s, vars) {
    return String(s).replace(/\{(\w+)\}/g, function (m, k) {
      return vars && vars[k] != null ? vars[k] : m;
    });
  }
  function el(html) { var t = d.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }
  function $(sel, root) { return (root || d).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }

  function businessDaysBetween(from, to) {
    var a = new Date(from), b = new Date(to), n = 0;
    a.setHours(0, 0, 0, 0); b.setHours(0, 0, 0, 0);
    while (a < b) {
      a.setDate(a.getDate() + 1);
      var wd = a.getDay();
      if (wd !== 0 && wd !== 6) n++;
    }
    return n;
  }
  function makeRef() {
    var A = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', p = function (n) {
      var s = '', r = w.crypto && w.crypto.getRandomValues ? w.crypto.getRandomValues(new Uint32Array(n)) : null;
      for (var i = 0; i < n; i++) s += A[(r ? r[i] : Math.floor(Math.random() * 4294967296)) % A.length];
      return s;
    };
    return 'PP-' + p(4) + '-' + p(4);
  }
  function norm(s) { return String(s || '').trim().toUpperCase().replace(/[\s‐-―_]+/g, '-'); }

  /* ------------------------------------------------------------------- boot */
  var root = $('[data-pp-root]');
  if (!root) return;

  var cfgNode = $('[data-pp-config]', root);
  var CFG;
  try { CFG = JSON.parse(cfgNode.textContent); } catch (e) { CFG = {}; }

  var S = (w.PP_PORTAL_SCHEMA || {});
  var UI = S.UI || {};
  var STEPS = S.SCHEMA || [];
  var DOCS = S.DOCS || [];
  var LAUNCH = S.LAUNCH || [];
  var PACK = S.PACK || [];
  var SHIP = S.SHIP || [];
  var INTL = w.PP_PORTAL_INTL || {};
  var COUNTRIES = INTL.countries || [];
  var REGIMES = INTL.regimes || [];
  var TRADE = INTL.trade || {};
  var DICT = (w.PP_PORTAL_I18N || {})[CFG.locale] || {};
  var CAT = CFG.catalogue || [];

  function t(key, vars) {
    var s = DICT[key] != null ? DICT[key] : (UI[key] != null ? UI[key] : key);
    return vars ? fmt(s, vars) : s;
  }
  /* schema strings are translated by a stable derived key, English inline is the fallback */
  function ts(key, english, vars) {
    var s = DICT[key] != null ? DICT[key] : english;
    return vars ? fmt(s, vars) : s;
  }

  var TERMVARS = {
    case: CFG.caseSize, moq: CFG.moqUnits,
    tOpen: CFG.testerOpening, tRe: CFG.testerReassort,
    email: CFG.contactEmail
  };

  /* ------------------------------------------------------------------ state */
  var ST;
  function blank() {
    return { v: 1, stage: 'gate', step: 0, data: {}, plan: {}, orderType: 'opening',
             docs: {}, tasks: {}, launch: {}, pack: {}, ref: '', submittedAt: '', confirmedAt: '', unlocked: false,
             medGroup: 'campaigns', medScent: '', medKind: '', medQuery: '', backStage: '',
             client: null, spaceTab: 'home', subLang: '', ship: {} };
  }
  function load() {
    try {
      var raw = w.localStorage.getItem(KEY);
      if (!raw) return blank();
      var o = JSON.parse(raw);
      var b = blank();
      for (var k in b) if (!(k in o)) o[k] = b[k];
      return o;
    } catch (e) { return blank(); }
  }
  function save() {
    try { w.localStorage.setItem(KEY, JSON.stringify(ST)); } catch (e) {}
    var badge = $('[data-saved]');
    if (badge) {
      badge.textContent = t('ui.savedAt', { time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) });
    }
  }
  ST = load();

  /* --------------------------------------------------- post-submit handshake */
  (function () {
    var posted = /[?&]contact_posted=true/.test(w.location.search);
    if (!posted) return;
    var which = '';
    try { which = w.localStorage.getItem(PENDING) || ''; } catch (e) {}
    if (!which) {
      var hsh = w.location.hash || '';
      which = hsh.indexOf('confirm') > -1 ? 'pack' : (hsh.indexOf('apply') > -1 ? 'apply' : (hsh.indexOf('ship') > -1 ? 'ship' : ''));
    }
    if (which === 'ship' && ST.client) {
      var sr = shipRec();
      sr.submittedAt = new Date().toISOString();
      if (!sr.ref) sr.ref = makeRef();
      ST.stage = 'space'; ST.spaceTab = 'home';
    } else if (which === 'apply') {
      ST.stage = 'review';
      if (!ST.submittedAt) ST.submittedAt = new Date().toISOString();
      if (!ST.ref) ST.ref = makeRef();
    } else if (which === 'pack') {
      ST.stage = 'done';
      ST.confirmedAt = new Date().toISOString();
    }
    try { w.localStorage.removeItem(PENDING); } catch (e) {}
    save();
    if (w.history && w.history.replaceState) {
      w.history.replaceState({}, '', w.location.pathname + (w.location.search.replace(/[?&]contact_posted=true/, '').replace(/^&/, '?') || ''));
    }
  })();

  /* ------------------------------------------------------------ country/regime */
  function countryRow(code) {
    for (var i = 0; i < COUNTRIES.length; i++) if (COUNTRIES[i].code === code) return COUNTRIES[i];
    return null;
  }
  function countryName(code) { var r = countryRow(code); return r ? r.name : (code || ''); }
  function regimeFor(code) {
    if (!code) return null;
    var fallback = null;
    for (var i = 0; i < REGIMES.length; i++) {
      var r = REGIMES[i];
      if (r.isFallback) { fallback = r; continue; }
      if (r.countries && r.countries.indexOf(code) > -1) return r;
    }
    if (fallback && fallback.countries && fallback.countries.indexOf(code) > -1) return fallback;
    return fallback;
  }

  /* -------------------------------------------------------------- catalogue */
  /* One row per sellable size. Testers are a label on a standard bottle, never a line. */
  function planRows() {
    var rows = [];
    CAT.forEach(function (p) {
      (p.variants || []).forEach(function (v) {
        var size = v.title === 'Default Title' ? '—' : v.title;
        if (/2\s*ml/i.test(size)) return;               /* samples are not a wholesale line here */
        rows.push({ sku: v.sku || (p.handle + '-' + size), name: p.title, size: size });
      });
    });
    return rows;
  }
  var ROWS = planRows();

  function planMath() {
    var caseSize = Math.max(1, CFG.caseSize | 0);
    var ratio = ST.orderType === 'reassort' ? Math.max(1, CFG.testerReassort | 0) : Math.max(1, CFG.testerOpening | 0);
    var units = 0, cases = 0, refs = 0, testers = 0, bad = [];
    ROWS.forEach(function (r) {
      var q = parseInt(ST.plan[r.sku], 10) || 0;
      if (q <= 0) return;
      refs++;
      units += q;
      cases += Math.ceil(q / caseSize);
      testers += Math.floor(q / ratio);
      if (q % caseSize !== 0) bad.push({ sku: r.sku, up: Math.ceil(q / caseSize) * caseSize });
    });
    var moqOk = ST.orderType === 'reassort' || units >= (CFG.moqUnits | 0);
    return { units: units, cases: cases, refs: refs, testers: testers, bad: bad, moqOk: moqOk, ratio: ratio, caseSize: caseSize };
  }

  /* --------------------------------------------------------- shipping file */
  /* One record per client slug, so two clients on the same browser never share a file. */
  function shipSlug() { return (ST.client && ST.client.slug) || ''; }
  function shipRec() {
    var k = shipSlug();
    if (!k) return { step: 0, data: {}, submittedAt: '', ref: '' };
    if (!ST.ship) ST.ship = {};
    if (!ST.ship[k]) ST.ship[k] = { step: 0, data: {}, submittedAt: '', ref: '' };
    return ST.ship[k];
  }
  function bucket(ns) {
    return ns === 'pack' ? ST.pack : (ns === 'launch' ? ST.launch : (ns === 'ship' ? shipRec().data : ST.data));
  }
  function keyPrefix(ns) { return ns === 'ship' ? 'sf.' : 'f.'; }

  /* ------------------------------------------------------------- validation */
  function allFields(step) { return (step.fields || []); }
  function isBlank(v) { return v == null || String(v).trim() === ''; }

  /* why a field failed, keyed by field — read by flagMissing to print the reason under it */
  var REASON = {};
  function validateIn(steps, data, i) {
    var step = steps[i], miss = [];
    allFields(step).forEach(function (f) {
      var v = data[f.k];
      delete REASON[f.k];
      var required = f.req || (f.reqIf && data[f.reqIf.k] === f.reqIf.v);
      if (required && (f.type === 'check' ? !v : isBlank(v))) { miss.push(f.k); return; }
      if (f.type === 'check' || isBlank(v)) return;
      if (f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { miss.push(f.k); return; }
      if (f.minLen && String(v).trim().length < f.minLen) {
        REASON[f.k] = t('ui.short', { n: f.minLen, m: String(v).trim().length }); miss.push(f.k); return;
      }
    });
    (step.terms || []).forEach(function (tm) { if (!data[tm.k]) miss.push(tm.k); });
    return miss;
  }
  function firstIncompleteIn(steps, data) {
    for (var i = 0; i < steps.length; i++) if (validateIn(steps, data, i).length) return i;
    return -1;
  }
  function validateStep(i) { return validateIn(STEPS, ST.data, i); }
  function firstIncompleteStep() { return firstIncompleteIn(STEPS, ST.data); }
  function validateShip(i) { return validateIn(SHIP, shipRec().data, i); }

  /* ------------------------------------------------------------ field render */
  function fieldHTML(f, ns) {
    var B = bucket(ns), P = keyPrefix(ns);
    var k = f.k, id = 'ppf-' + ns + '-' + k, v = B[k];
    var cls = 'pp-pp__field' + (f.wide ? ' pp-pp__field--wide' : '');
    var label = ts(P + k + '.l', f.label);
    var hint = f.hint ? ts(P + k + '.h', f.hint) : '';
    var ph = f.ph ? ts(P + k + '.p', f.ph) : '';

    if (f.type === 'check') {
      return '<label class="pp-pp__check pp-pp__field--wide" data-field="' + k + '">' +
        '<input type="checkbox" id="' + id + '" data-k="' + k + '" data-ns="' + ns + '"' + (v ? ' checked' : '') + '>' +
        '<span>' + esc(label) + (hint ? ' ' + esc(hint) : '') + '</span></label>';
    }

    /* label and hint can be driven by the selected country row */
    if (f.labelFrom) {
      var cr = countryRow(B.country);
      if (cr && cr[f.labelFrom]) label = cr[f.labelFrom];
    }
    if (f.hintFrom) {
      var cr2 = countryRow(B.country);
      if (cr2 && cr2[f.hintFrom]) ph = cr2[f.hintFrom];
    }

    var ctl;
    if (f.type === 'select' || f.type === 'country') {
      var opts = '<option value="">' + esc(t('ui.select')) + '</option>';
      if (f.type === 'country') {
        if (!COUNTRIES.length) {
          ctl = '<input type="text" id="' + id + '" data-k="' + k + '" data-ns="' + ns + '" value="' + esc(v) + '">';
        } else {
          COUNTRIES.forEach(function (c) {
            opts += '<option value="' + esc(c.code) + '"' + (v === c.code ? ' selected' : '') + '>' + esc(c.name) + '</option>';
          });
          ctl = '<select id="' + id + '" data-k="' + k + '" data-ns="' + ns + '">' + opts + '</select>';
        }
      } else {
        var list = f.optsFrom === 'incoterms'
          ? (TRADE.incoterms || []).map(function (i) { return i.code + ' — ' + i.plain; })
          : (f.opts || []);
        if (f.optsFrom === 'incoterms' && !list.length) {
          list = ['EXW — you collect from our warehouse', 'FCA — we hand to your forwarder',
                  'DAP — we deliver, you clear and pay duty', 'DDP — we deliver cleared'];
        }
        list.forEach(function (o, ix) {
          var lab = ts(P + k + '.o.' + ix, o);
          opts += '<option value="' + esc(o) + '"' + (v === o ? ' selected' : '') + '>' + esc(lab) + '</option>';
        });
        ctl = '<select id="' + id + '" data-k="' + k + '" data-ns="' + ns + '">' + opts + '</select>';
      }
    } else if (f.type === 'textarea') {
      ctl = '<textarea id="' + id + '" rows="' + (f.rows || 3) + '" data-k="' + k + '" data-ns="' + ns + '"' +
            (ph ? ' placeholder="' + esc(ph) + '"' : '') + '>' + esc(v) + '</textarea>';
    } else {
      var type = f.type === 'number' ? 'number' : (f.type === 'email' ? 'email' : (f.type === 'tel' ? 'tel' : (f.type === 'url' ? 'url' : 'text')));
      ctl = '<input type="' + type + '" id="' + id + '" data-k="' + k + '" data-ns="' + ns + '" value="' + esc(v) + '"' +
            (f.min != null ? ' min="' + f.min + '"' : '') +
            (f.num ? ' inputmode="numeric"' : '') +
            (f.ac ? ' autocomplete="' + esc(f.ac) + '"' : '') +
            (ph ? ' placeholder="' + esc(ph) + '"' : '') + '>';
    }

    return '<label class="' + cls + '" data-field="' + k + '">' +
             '<span>' + esc(label) + (f.req ? ' <b>*</b>' : '') + '</span>' + ctl +
             (hint ? '<em>' + esc(hint) + '</em>' : '') +
             '<em class="pp-pp__field-err" data-ferr hidden></em>' +
           '</label>';
  }


  /* ------------------------------------------------------------------- media */
  /* The library. Files come from the theme (resolved to CDN urls by the Liquid
     section) and from the live product records, so a tile can never point at a
     file that is not actually published. */
  var MED   = (w.PP_PORTAL_MEDIA || {});
  var MGRP  = MED.GROUPS || [];
  var MSCE  = MED.SCENTS || [];
  var MKIND = MED.KINDS || [];
  var MITEM = MED.ITEMS || [];
  var MTRAN = MED.TRANSPORT || [];
  var ASSETS = CFG.assets || {};
  var ACC = CFG.account || {};
  var MCFG = CFG.media || {};

  function assetUrl(name) { return ASSETS[name] || ''; }

  var SCENT_MATCH = [
    ['albatre', 'albatre'], ['albâtre', 'albatre'], ['rose-monotone', 'rose'], ['insuline', 'insuline'],
    ['gravitas', 'gravitas'], ['simili', 'simili'], ['nuit', 'nuit'], ['doppel', 'doppel']
  ];
  function scentOf(handle) {
    var h = String(handle || '').toLowerCase();
    for (var i = 0; i < SCENT_MATCH.length; i++) if (h.indexOf(SCENT_MATCH[i][0]) > -1) return SCENT_MATCH[i][1];
    return 'house';
  }
  function scentName(k) {
    for (var i = 0; i < MSCE.length; i++) if (MSCE[i].k === k) return ts('m.scent.' + k, MSCE[i].n);
    return k;
  }

  /* live product photography, straight off the storefront records */
  function livePackshots() {
    var out = [];
    CAT.forEach(function (p) {
      (p.shots || []).forEach(function (sh, ix) {
        out.push({
          k: 'ps_' + p.handle + '_' + ix, g: 'packshots', s: scentOf(p.handle), t: 'packshot',
          n: p.title + ' — ' + t('ui.med.shotN', { n: ix + 1 }),
          d: t('ui.med.liveShot'), w: sh.w, h: sh.h, live: true,
          url: sh.full, thumb: sh.thumb, file: p.handle + '-' + (ix + 1) + '.jpg'
        });
      });
    });
    return out;
  }

  var MEDIA_CACHE = null;
  function mediaItems() {
    if (MEDIA_CACHE) return MEDIA_CACHE;
    var list = [];
    MITEM.forEach(function (it) {
      var url = assetUrl(it.a);
      /* A safety data sheet the section did not publish has no URL by design — the file is
         never exposed. Keep the tile and turn it into a request rather than hiding the
         document's existence from a distributor who legitimately needs it. */
      var onRequest = !url && it.doc;
      if (!url && !onRequest) return;         /* never show a tile we cannot serve */
      var o = {};
      for (var q in it) o[q] = it[q];
      o.url = url || '';
      o.onRequest = onRequest;
      o.thumb = it.p ? assetUrl(it.p) : (isVideo(it.a) ? '' : url);
      o.file = it.a;
      list.push(o);
    });
    MEDIA_CACHE = list.concat(livePackshots());
    return MEDIA_CACHE;
  }
  function isVideo(name) { return /\.(mp4|mov|webm)$/i.test(name || ''); }
  function isDoc(name)   { return /\.pdf$/i.test(name || ''); }

  function bytes(n) {
    if (!n) return '';
    if (n < 1024) return n + ' B';
    if (n < 1048576) return Math.round(n / 1024) + ' KB';
    return (n / 1048576).toFixed(1).replace(/\.0$/, '') + ' MB';
  }
  function itemName(it) { return it.live ? it.n : ts('m.' + it.k + '.n', it.n); }
  function itemNote(it) { return it.live ? it.d : ts('m.' + it.k + '.d', it.d); }

  function itemMeta(it) {
    var bits = [];
    if (it.dur) bits.push(it.dur + 's');
    if (it.w && it.h) bits.push(it.w + '×' + it.h);
    if (it.pages) bits.push(it.pages === 1 ? t('ui.med.page1') : t('ui.med.pages', { n: it.pages }));
    /* the CDN re-encodes images, so only video and PDF weigh what the manifest says */
    if (it.b && (isVideo(it.file) || isDoc(it.file))) bits.push(bytes(it.b));
    return bits.join(' · ');
  }

  /* what the visitor may see right now */
  function mediaAccess() {
    if (!MCFG.enabled) return 'off';
    /* The access code is the gate. The library sits behind it — the top bar that leads
       here only exists once the visitor is past the gate — so there is nothing further
       to sign in to. */
    return 'open';
  }
  function docsUnlocked() {
    /* Nothing here is gated on a customer tag any more: the access code carries the whole
       portal. What keeps the safety data sheets private is that the section never emits
       their URLs — see publish_sds. */
    return true;
  }

  function filteredMedia() {
    var g = ST.medGroup || 'campaigns';
    var s = ST.medScent || '';
    var k = ST.medKind || '';
    var q = (ST.medQuery || '').toLowerCase().trim();
    return mediaItems().filter(function (it) {
      if (it.g !== g) return false;
      if (s && it.s !== s) return false;
      if (k && it.t !== k) return false;
      if (q && (itemName(it) + ' ' + itemNote(it)).toLowerCase().indexOf(q) < 0) return false;
      return true;
    });
  }

  /* A prewritten request for a document we do not publish. Carries whatever the applicant
     has already told us, so Pierre can answer without a round trip asking who they are. */
  /* The item's own name already says what the document is ("Albâtre Sépia — safety data
     sheet"), and the subject line says it too. Use the fragrance alone so the mail does not
     read "Safety data sheet — Albâtre Sépia — safety data sheet". The FDA certificate has no
     fragrance, so it keeps its full name. */
  function docLabel(it) {
    if (it.s && it.s !== 'house') return scentName(it.s);
    return itemName(it);
  }

  function requestMailto(it) {
    var st = ST || {}, d = st.data || {};
    var lines = [
      t('ui.med.reqBodyOpen'),
      '',
      t('ui.med.reqBodyAsk', { doc: docLabel(it) }),
      '',
      t('ui.med.reqCompany') + ': ' + (d.legal_name || ''),
      t('ui.med.reqCountry') + ': ' + (countryName(d.country) || ''),
      t('ui.med.reqRef') + ': ' + (st.ref || t('ui.med.reqNoRef')),
      t('ui.med.reqWho') + ': ' + (d.buyer_name || '') + (d.buyer_email ? ' — ' + d.buyer_email : ''),
      '',
      t('ui.med.reqPurpose'),
      '',
      t('ui.med.reqBodyClose')
    ];
    return 'mailto:' + encodeURIComponent(CFG.contactEmail).replace(/%40/g, '@') +
      '?subject=' + encodeURIComponent(t('ui.med.reqSubject', { doc: docLabel(it) })) +
      '&body=' + encodeURIComponent(lines.join('\n'));
  }

  function tileHTML(it) {
    var thumb = it.thumb || '';
    var vid = isVideo(it.file);
    var doc = isDoc(it.file);
    var visual = doc
      ? '<span class="pp-pp__tile-doc"><b>PDF</b></span>'
      : (thumb
          ? '<img src="' + esc(thumb) + '" alt="" loading="lazy" decoding="async">'
          : '<span class="pp-pp__tile-doc"><b>' + (vid ? 'MP4' : 'IMG') + '</b></span>');
    var cls = 'pp-pp__tile' + (doc ? ' is-doc' : '') +
      (it.bg === 'light' ? ' is-art-light' : (it.bg === 'dark' ? ' is-art-dark' : ''));
    return '<article class="' + cls + '" data-media="' + esc(it.k) + '">' +
      '<button class="pp-pp__tile-vis" type="button" data-media-open="' + esc(it.k) + '" ' +
        'aria-label="' + esc(itemName(it)) + '">' + visual +
        (vid ? '<span class="pp-pp__tile-play" aria-hidden="true"></span>' : '') +
      '</button>' +
      '<div class="pp-pp__tile-txt">' +
        '<h4>' + esc(itemName(it)) + '</h4>' +
        '<p class="pp-pp__tile-meta">' + esc(itemMeta(it)) + '</p>' +
        '<p>' + esc(itemNote(it)) + '</p>' +
        '<div class="pp-pp__tile-act">' +
          (it.onRequest
            ? '<a class="pp-pp__btn pp-pp__btn--ghost" href="' + esc(requestMailto(it)) + '">' + esc(t('ui.med.request')) + '</a>'
            : '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-media-get="' + esc(it.k) + '">' + esc(t('ui.med.get')) + '</button>' +
              '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-media-copy="' + esc(it.k) + '">' + esc(t('ui.med.copy')) + '</button>') +
        '</div>' +
      '</div>' +
    '</article>';
  }

  function chipsHTML() {
    var scents = [{ k: '', n: t('ui.med.allScents') }].concat(MSCE.map(function (x) { return { k: x.k, n: scentName(x.k) }; }));
    var kinds  = [{ k: '', n: t('ui.med.allKinds') }].concat(MKIND.map(function (x) { return { k: x.k, n: ts('m.kind.' + x.k, x.n) }; }));
    var pool = mediaItems().filter(function (it) { return it.g === (ST.medGroup || 'campaigns'); });
    function keep(list, field) {
      return list.filter(function (c) {
        if (!c.k) return true;
        return pool.some(function (it) { return it[field] === c.k; });
      });
    }
    var s = keep(scents, 's').map(function (c) {
      return '<button class="pp-pp__chip' + ((ST.medScent || '') === c.k ? ' is-on' : '') + '" type="button" data-med-scent="' + esc(c.k) + '">' + esc(c.n) + '</button>';
    }).join('');
    var k = keep(kinds, 't').map(function (c) {
      return '<button class="pp-pp__chip' + ((ST.medKind || '') === c.k ? ' is-on' : '') + '" type="button" data-med-kind="' + esc(c.k) + '">' + esc(c.n) + '</button>';
    }).join('');
    return '<div class="pp-pp__chips">' + s + '</div><div class="pp-pp__chips">' + k + '</div>';
  }

  function transportHTML() {
    var rows = MTRAN.map(function (r) {
      return '<tr><th>' + esc(ts('m.tr.' + r.k, r.n)) + '</th><td>' + esc(r.v) + '</td></tr>';
    }).join('');
    var gt = [];
    CAT.forEach(function (p) {
      (p.variants || []).forEach(function (v) {
        if (!v.sku) return;
        if (/(SP2ML|MICROG0[12])$/i.test(v.sku)) return;              /* 2 ml is not a wholesale line */
        var vt = (v.title && v.title !== 'Default Title') ? v.title : '—';
        gt.push('<tr><td>' + esc(p.title) + '</td><td>' + esc(vt) + '</td><td class="pp-pp__mono">' + esc(v.sku) + '</td><td class="pp-pp__mono">' + esc(v.barcode || '—') + '</td></tr>');
      });
    });
    return '<div class="pp-pp__docdata">' +
      '<div class="pp-pp__card">' +
        '<h3>' + esc(t('ui.med.transport')) + '</h3>' +
        '<table class="pp-pp__kv">' + rows + '</table>' +
        '<p class="pp-pp__hint">' + esc(t('ui.med.transportNote')) + '</p>' +
      '</div>' +
      '<div class="pp-pp__card">' +
        '<h3>' + esc(t('ui.med.gtin')) + '</h3>' +
        '<div class="pp-pp__scroll"><table class="pp-pp__grid-table"><thead><tr>' +
          '<th>' + esc(t('ui.med.thProduct')) + '</th><th>' + esc(t('ui.med.thSize')) + '</th>' +
          '<th>' + esc(t('ui.med.thSku')) + '</th><th>' + esc(t('ui.med.thGtin')) + '</th>' +
        '</tr></thead><tbody>' + (gt.join('') || '<tr><td colspan="4">—</td></tr>') + '</tbody></table></div>' +
        '<p class="pp-pp__hint">' + esc(t('ui.med.gtinNote')) + '</p>' +
      '</div>' +
    '</div>';
  }

  function screenMedia() {
    var acc = mediaAccess();
    var g = ST.medGroup || 'campaigns';
    var grp = MGRP.filter(function (x) { return x.k === g; })[0] || MGRP[0] || { k: 'campaigns', n: 'Campaigns', d: '' };

    var tabs = MGRP.map(function (x) {
      return '<button class="pp-pp__mtab' + (x.k === g ? ' is-on' : '') + '" type="button" data-med-group="' + esc(x.k) + '">' +
        esc(ts('m.group.' + x.k + '.n', x.n)) + '</button>';
    }).join('');

    var head = '<header class="pp-pp__masthead">' +
        '<p class="pp-pp__eyebrow">' + esc(t('ui.med.eyebrow')) + '</p>' +
        '<h1 class="pp-pp__title">' + esc(t('ui.med.title')) + '</h1>' +
        '<p class="pp-pp__lede">' + esc(t('ui.med.lede')) + '</p>' +
      '</header>';

    if (acc === 'off') {
      return head + '<div class="pp-pp__card"><p>' + esc(t('ui.med.off', { email: CFG.contactEmail })) + '</p></div>' + mediaFoot();
    }
    if (acc === 'signin') {
      return head + accountCardHTML(true) + mediaFoot();
    }

    var locked = g === 'inci' && !docsUnlocked();
    var list = filteredMedia();
    var body;
    if (locked) {
      body = '<div class="pp-pp__card pp-pp__locked">' +
        '<h3>' + esc(t('ui.med.lockTitle')) + '</h3>' +
        '<p>' + esc(t('ui.med.lockBody')) + '</p>' +
        '<p class="pp-pp__hint">' + t('ui.med.lockFoot', { email: '<a href="mailto:' + esc(CFG.contactEmail) + '">' + esc(CFG.contactEmail) + '</a>' }) + '</p>' +
      '</div>';
    } else {
      body = chipsHTML() +
        '<div class="pp-pp__medbar">' +
          '<label class="pp-pp__sr" for="pp-med-q">' + esc(t('ui.med.search')) + '</label>' +
          '<input id="pp-med-q" class="pp-pp__medsearch" type="search" autocomplete="off" spellcheck="false" ' +
            'placeholder="' + esc(t('ui.med.search')) + '" value="' + esc(ST.medQuery || '') + '" data-med-q>' +
          '<span class="pp-pp__medcount">' + esc(t('ui.med.count', { n: list.length })) + '</span>' +
          '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-med-copyall>' + esc(t('ui.med.copyAll')) + '</button>' +
          '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-med-list>' + esc(t('ui.med.saveList')) + '</button>' +
        '</div>' +
        (list.length
          ? '<div class="pp-pp__mgrid">' + list.map(tileHTML).join('') + '</div>'
          : '<p class="pp-pp__hint">' + esc(t('ui.med.empty')) + '</p>') +
        (g === 'inci' ? transportHTML() : '');
    }

    return head +
      '<div class="pp-pp__mtabs" role="tablist">' + tabs + '</div>' +
      '<p class="pp-pp__lede pp-pp__lede--sm">' + esc(ts('m.group.' + grp.k + '.d', grp.d)) + '</p>' +
      body +
      '<p class="pp-pp__hint pp-pp__medfoot">' + t('ui.med.ask', { email: '<a href="mailto:' + esc(CFG.contactEmail) + '">' + esc(CFG.contactEmail) + '</a>' }) + '</p>' +
      mediaFoot();
  }

  function mediaFoot() {
    return '<div class="pp-pp__foot">' +
      '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-med-back>' + esc(t('ui.med.back')) + '</button>' +
      '<a href="mailto:' + esc(CFG.contactEmail) + '">' + esc(CFG.contactEmail) + '</a>' +
      '<span class="pp-pp__saved" data-saved></span></div>';
  }

  /* ---- account ---- */
  function accountCardHTML(forMedia) {
    if (ACC.signedIn) {
      return '<div class="pp-pp__acct is-in">' +
        '<div>' +
          '<h3>' + esc(t('ui.acct.inTitle', { name: ACC.name || ACC.email })) + '</h3>' +
          '<p>' + esc(ACC.partner ? t('ui.acct.inPartner') : t('ui.acct.inPlain')) + '</p>' +
        '</div>' +
        '<div class="pp-pp__acct-act">' +
          '<a class="pp-pp__btn pp-pp__btn--ghost" href="' + esc(ACC.accountUrl) + '">' + esc(t('ui.acct.manage')) + '</a>' +
          '<a class="pp-pp__btn pp-pp__btn--ghost" href="' + esc(ACC.logoutUrl) + '">' + esc(t('ui.acct.out')) + '</a>' +
        '</div>' +
      '</div>';
    }
    return '<div class="pp-pp__acct">' +
      '<div>' +
        '<h3>' + esc(forMedia ? t('ui.acct.mediaTitle') : t('ui.acct.outTitle')) + '</h3>' +
        '<p>' + esc(forMedia ? t('ui.acct.mediaBody') : t('ui.acct.outBody')) + '</p>' +
        '<p class="pp-pp__hint">' + esc(t('ui.acct.how')) + '</p>' +
      '</div>' +
      '<div class="pp-pp__acct-act">' +
        '<a class="pp-pp__btn pp-pp__btn--solid" href="' + esc(ACC.loginUrl) + '">' + esc(t('ui.acct.create')) + '</a>' +
      '</div>' +
    '</div>';
  }

  /* a thin bar carried on every screen once the visitor is past the gate */
  function topBar() {
    if (ST.stage === 'gate' || ST.stage === 'space') return '';
    var bits = '';
    if (MCFG.enabled) {
      bits += '<button class="pp-pp__toplink' + (ST.stage === 'media' ? ' is-on' : '') + '" type="button" data-med-open>' +
        esc(t('ui.med.open')) + '</button>';
    }
    if (ST.stage === 'media') {
      bits += '<button class="pp-pp__toplink" type="button" data-med-back>' + esc(t('ui.med.back')) + '</button>';
    }
    if (ACC.signedIn) {
      bits += '<span class="pp-pp__topwho">' + esc(ACC.name || ACC.email) + '</span>';
    }
    return '<div class="pp-pp__topbar">' + bits + '</div>';
  }

  /* ---- lightbox ---- */
  function findItem(k) {
    var all = mediaItems();
    for (var i = 0; i < all.length; i++) if (all[i].k === k) return all[i];
    return null;
  }
  function openLightbox(k) {
    var it = findItem(k);
    if (!it) return;
    closeLightbox();
    var vis;
    if (isVideo(it.file)) {
      vis = '<video src="' + esc(it.url) + '" controls playsinline preload="metadata"' +
            (it.thumb ? ' poster="' + esc(it.thumb) + '"' : '') + '></video>';
    } else if (isDoc(it.file)) {
      vis = it.onRequest
        ? '<div class="pp-pp__lb-doc"><b>PDF</b><p>' + esc(t('ui.med.reqWhy')) + '</p>' +
          '<a class="pp-pp__btn pp-pp__btn--solid" href="' + esc(requestMailto(it)) + '">' + esc(t('ui.med.request')) + '</a></div>'
        : '<div class="pp-pp__lb-doc"><b>PDF</b><p>' + esc(itemMeta(it)) + '</p>' +
          '<a class="pp-pp__btn pp-pp__btn--solid" href="' + esc(it.url) + '" target="_blank" rel="noopener">' + esc(t('ui.med.openDoc')) + '</a></div>';
    } else {
      vis = '<img class="' + (it.bg === 'light' ? 'is-art-light' : (it.bg === 'dark' ? 'is-art-dark' : '')) + '" src="' + esc(it.url) + '" alt="' + esc(itemName(it)) + '">';
    }
    var node = el('<div class="pp-pp__lb" data-lb role="dialog" aria-modal="true">' +
      '<button class="pp-pp__lb-close" type="button" data-lb-close aria-label="' + esc(t('ui.med.close')) + '">×</button>' +
      '<div class="pp-pp__lb-inner">' +
        '<div class="pp-pp__lb-vis">' + vis + '</div>' +
        '<div class="pp-pp__lb-txt">' +
          '<h3>' + esc(itemName(it)) + '</h3>' +
          '<p class="pp-pp__tile-meta">' + esc(itemMeta(it)) + '</p>' +
          '<p>' + esc(itemNote(it)) + '</p>' +
          '<div class="pp-pp__tile-act">' +
            (it.onRequest
              ? '<a class="pp-pp__btn pp-pp__btn--solid" href="' + esc(requestMailto(it)) + '">' + esc(t('ui.med.request')) + '</a>'
              : '<button class="pp-pp__btn pp-pp__btn--solid" type="button" data-media-get="' + esc(it.k) + '">' + esc(t('ui.med.get')) + '</button>' +
                '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-media-copy="' + esc(it.k) + '">' + esc(t('ui.med.copy')) + '</button>') +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>');
    d.body.appendChild(node);
    d.documentElement.style.overflow = 'hidden';
    node.addEventListener('click', function (ev) {
      if (ev.target === node || ev.target.hasAttribute('data-lb-close')) closeLightbox();
    });
    var c = $('[data-lb-close]', node); if (c) c.focus();
  }
  function closeLightbox() {
    var n = $('[data-lb]');
    if (n) { n.parentNode.removeChild(n); d.documentElement.style.overflow = ''; }
  }
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });

  /* ---- getting files out ---- */
  function downloadItem(k, btn) {
    var it = findItem(k);
    if (!it) return;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = t('ui.med.getting'); }
    function done() { if (btn) { btn.disabled = false; btn.textContent = label; } }
    if (!w.fetch || !w.URL || !w.URL.createObjectURL) { w.open(it.url, '_blank', 'noopener'); done(); return; }
    w.fetch(it.url, { mode: 'cors' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.blob();
    }).then(function (blob) {
      var u = w.URL.createObjectURL(blob);
      var a = d.createElement('a');
      a.href = u; a.download = it.file || (it.k + '.bin');
      d.body.appendChild(a); a.click(); d.body.removeChild(a);
      setTimeout(function () { w.URL.revokeObjectURL(u); }, 4000);
      done();
    })['catch'](function () { w.open(it.url, '_blank', 'noopener'); done(); });
  }

  function flash(btn, key) {
    if (!btn) return;
    var old = btn.getAttribute('data-lbl') || btn.textContent;
    btn.setAttribute('data-lbl', old);
    btn.textContent = t(key);
    setTimeout(function () { btn.textContent = btn.getAttribute('data-lbl') || old; }, 1600);
  }
  function toClipboard(text, btn) {
    function fallback() {
      var ta = d.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      d.body.appendChild(ta); ta.select();
      try { d.execCommand('copy'); } catch (e) {}
      d.body.removeChild(ta);
      flash(btn, 'ui.med.copied');
    }
    if (w.navigator && w.navigator.clipboard && w.navigator.clipboard.writeText) {
      w.navigator.clipboard.writeText(text).then(function () { flash(btn, 'ui.med.copied'); })['catch'](fallback);
    } else fallback();
  }
  function currentList() {
    return filteredMedia().map(function (it) { return itemName(it) + '\t' + it.url; }).join('\n');
  }
  function saveList() {
    var head = CFG.brand + ' — ' + t('ui.med.title') + '\n' +
      (MGRP.filter(function (x) { return x.k === (ST.medGroup || 'campaigns'); })[0] || {}).n + '\n' +
      new Date().toISOString().slice(0, 10) + '\n\n';
    var blob = new Blob([head + currentList() + '\n'], { type: 'text/plain;charset=utf-8' });
    var u = w.URL.createObjectURL(blob);
    var a = d.createElement('a');
    a.href = u; a.download = 'premiere-peau-media-' + (ST.medGroup || 'campaigns') + '.txt';
    d.body.appendChild(a); a.click(); d.body.removeChild(a);
    setTimeout(function () { w.URL.revokeObjectURL(u); }, 4000);
  }

  /* ------------------------------------------------------------ client spaces */
  /* One password = one client space. The page ships every client record encrypted
     (AES-256-GCM) under a key derived from that client's password (PBKDF2-SHA256);
     the source names nobody. The password is obscurity-grade like the access code —
     what it protects is the client list, not the media, whose URLs are public CDN. */
  var CL = (w.PP_PORTAL_CLIENTS || {});
  var GEO_ALL = (w.PP_PORTAL_GEO || {});
  var FILMS = CFG.films || {};
  var SUBS = CFG.subs || {};
  var SPACE_TABS = ['home', 'training', 'films', 'media', 'prices', 'docs'];

  function b64ToBytes(b) {
    var bin = w.atob(b), u = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
    return u;
  }
  function bytesToB64(u) {
    var bin = '';
    for (var i = 0; i < u.length; i++) bin += String.fromCharCode(u[i]);
    return w.btoa(bin);
  }
  function hasCrypto() { return !!(w.crypto && w.crypto.subtle && w.TextEncoder); }

  /* resolves to the decrypted client manifest, or null when the password opens nothing */
  function unlockClient(password) {
    if (!hasCrypto() || !CL.items) return Promise.resolve(null);
    var enc = new w.TextEncoder();
    var sub = w.crypto.subtle;
    return sub.importKey('raw', enc.encode(norm(password)), 'PBKDF2', false, ['deriveBits']).then(function (base) {
      return sub.deriveBits({ name: 'PBKDF2', hash: 'SHA-256', salt: enc.encode(CL.salt || ''), iterations: CL.iterations || 200000 }, base, 512);
    }).then(function (bits) {
      var u = new Uint8Array(bits);
      var rec = CL.items[bytesToB64(u.slice(0, 16))];
      if (!rec) return null;
      return sub.importKey('raw', u.slice(16, 48), 'AES-GCM', false, ['decrypt']).then(function (key) {
        return sub.decrypt({ name: 'AES-GCM', iv: b64ToBytes(rec.iv) }, key, b64ToBytes(rec.ct));
      }).then(function (pt) {
        try { return JSON.parse(new w.TextDecoder().decode(pt)); } catch (e) { return null; }
      });
    })['catch'](function () { return null; });
  }

  function geoPack() {
    var dict = GEO_ALL[CFG.locale] || GEO_ALL.en || {};
    var c = ST.client || {};
    return dict[c.geo] || (GEO_ALL.en || {})[c.geo] || null;
  }
  function geoLabel() { var g = geoPack(); return g ? g.label : ((ST.client || {}).country || ''); }
  function fmtDate(iso) {
    if (!iso) return '';
    try { return new Date(iso + 'T12:00:00').toLocaleDateString(CFG.locale === 'en' ? 'en-GB' : CFG.locale, { year: 'numeric', month: 'long', day: 'numeric' }); } catch (e) { return iso; }
  }
  function subLangs(which) {
    var m = SUBS[which] || {};
    return Object.keys(m).filter(function (k) { return !!m[k]; });
  }
  function langLabel(code) {
    var L = { en: 'English', fr: 'Français', de: 'Deutsch', es: 'Español', it: 'Italiano', nl: 'Nederlands', ja: '日本語', ko: '한국어',
              ar: 'العربية', 'zh-TW': '繁體中文', 'zh-CN': '简体中文', pt: 'Português', cs: 'Čeština', el: 'Ελληνικά' };
    return L[code] || code;
  }
  function preferredSub(which) {
    var langs = subLangs(which);
    var want = ST.subLang || (ST.client && ST.client.lang) || CFG.locale || 'en';
    if (langs.indexOf(want) > -1) return want;
    if (langs.indexOf(CFG.locale) > -1) return CFG.locale;
    return langs.indexOf('en') > -1 ? 'en' : (langs[0] || '');
  }

  function priceTableHTML(g) {
    if (!g) return '';
    var rows = (g.prices || []).map(function (r) {
      return '<tr><td>' + esc(r.item) + '</td><td class="num">' + esc(r.price) + '</td></tr>';
    }).join('');
    return '<div class="pp-pp__scroll"><table class="pp-pp__prices"><thead><tr>' +
      '<th>' + esc(t('ui.space.prices.item')) + '</th><th class="num">' + esc(t('ui.space.prices.price')) + '</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table></div>' +
      (g.taxNote ? '<p class="pp-pp__hint">' + esc(g.taxNote) + '</p>' : '');
  }

  function spaceHeader() {
    var c = ST.client || {};
    var g = geoPack();
    return '<header class="pp-pp__masthead pp-pp__space-head">' +
      '<p class="pp-pp__eyebrow">' + esc(t('ui.space.eyebrow')) + '</p>' +
      '<h1 class="pp-pp__title">' + esc(t('ui.space.welcome', { client: c.name || '' })) + '</h1>' +
      '<p class="pp-pp__lede">' + esc(t('ui.space.lede', { geo: g ? g.label : (c.country || '') })) + '</p>' +
      '<div class="pp-pp__space-meta">' +
        '<span class="pp-pp__space-status"><i></i>' + esc(t('ui.space.status')) + '</span>' +
        (c.ref ? '<span class="pp-pp__mono">' + esc(t('ui.space.order', { ref: c.ref, date: fmtDate(c.date) })) + '</span>' : '') +
      '</div>' +
    '</header>';
  }
  function spaceTabs() {
    var cur = ST.spaceTab || 'home';
    return '<div class="pp-pp__mtabs pp-pp__space-tabs" role="tablist">' + SPACE_TABS.map(function (k) {
      if (k === 'media' && !MCFG.enabled) return '';
      return '<button class="pp-pp__mtab' + (k === cur ? ' is-on' : '') + '" type="button" role="tab" data-space-tab="' + k + '">' +
        esc(t('ui.space.tab.' + k)) + '</button>';
    }).join('') + '</div>';
  }
  function contactCardHTML() {
    var c = ST.client || {};
    var mail = c.contactEmail || CFG.contactEmail;
    return '<div class="pp-pp__card pp-pp__space-contact">' +
      '<h3>' + esc(t('ui.space.contact')) + '</h3>' +
      '<p class="pp-pp__space-who">' + esc(c.contactName || CFG.brand) + '</p>' +
      '<p><a href="mailto:' + esc(mail) + '">' + esc(mail) + '</a></p>' +
    '</div>';
  }
  function tabHome() {
    var links = ['training', 'films', 'media', 'prices', 'docs'].filter(function (k) { return k !== 'media' || MCFG.enabled; }).map(function (k) {
      return '<button class="pp-pp__space-link" type="button" data-space-tab="' + k + '"><span>' + esc(t('ui.space.tab.' + k)) + '</span><i>→</i></button>';
    }).join('');
    return '<div class="pp-pp__status pp-pp__space-home">' +
      '<div class="pp-pp__card">' +
        '<h3>' + esc(t('ui.space.home.next')) + '</h3>' +
        '<p>' + esc(t('ui.space.home.nextBody')) + '</p>' +
        '<p class="pp-pp__hint">' + t('ui.space.home.help', { email: '<a href="mailto:' + esc((ST.client || {}).contactEmail || CFG.contactEmail) + '">' + esc((ST.client || {}).contactEmail || CFG.contactEmail) + '</a>' }) + '</p>' +
      '</div>' +
      '<div class="pp-pp__space-side">' + contactCardHTML() + '<div class="pp-pp__space-links">' + links + '</div></div>' +
    '</div>';
  }
  function tabTraining() {
    return '<div class="pp-pp__card pp-pp__space-card">' +
      '<h3>' + esc(t('ui.space.training.title')) + '</h3>' +
      '<p>' + esc(t('ui.space.training.lede')) + '</p>' +
      '<div class="pp-pp__tile-act">' +
        '<button class="pp-pp__btn pp-pp__btn--solid" type="button" data-training-open>' + esc(t('ui.space.training.open')) + '</button>' +
        '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-training-print hidden>' + esc(t('ui.space.training.print')) + '</button>' +
      '</div>' +
      '<p class="pp-pp__hint">' + esc(t('ui.space.training.hint')) + '</p>' +
    '</div>' +
    '<div class="pp-pp__frame-wrap" data-training-host hidden><iframe class="pp-pp__frame" title="' + esc(t('ui.space.training.title')) + '" sandbox="allow-scripts allow-popups allow-modals allow-top-navigation-by-user-activation"></iframe></div>';
  }
  function filmHTML(which, titleKey, noteKey, vertical) {
    var f = FILMS[which] || {};
    if (!f.src) return '';
    var langs = subLangs(which), pref = preferredSub(which);
    var tracks = langs.map(function (code) {
      return '<track kind="subtitles" srclang="' + esc(code) + '" label="' + esc(langLabel(code)) + '" src="' + esc(SUBS[which][code]) + '"' + (code === pref ? ' default' : '') + '>';
    }).join('');
    var sel = langs.length ? '<label class="pp-pp__space-sub"><span>' + esc(t('ui.space.films.subs')) + '</span><select data-sub-lang="' + which + '">' +
      langs.map(function (code) { return '<option value="' + esc(code) + '"' + (code === pref ? ' selected' : '') + '>' + esc(langLabel(code)) + '</option>'; }).join('') +
      '</select></label>' : '';
    return '<div class="pp-pp__film' + (vertical ? ' is-vertical' : '') + '">' +
      '<div class="pp-pp__film-vis"><video controls playsinline preload="metadata"' + (f.poster ? ' poster="' + esc(f.poster) + '"' : '') + ' data-film="' + which + '">' +
        '<source src="' + esc(f.src) + '" type="video/mp4">' + tracks + '</video></div>' +
      '<div class="pp-pp__film-txt">' +
        '<h3>' + esc(t(titleKey)) + '</h3>' +
        '<p>' + esc(t(noteKey)) + '</p>' +
        sel +
        '<div class="pp-pp__tile-act"><a class="pp-pp__btn pp-pp__btn--ghost" href="' + esc(f.download || f.src) + '" download target="_blank" rel="noopener">' + esc(t('ui.space.films.download')) + '</a></div>' +
      '</div>' +
    '</div>';
  }
  function tabFilms() {
    var n = Math.max(subLangs('reel').length, subLangs('long').length);
    return '<div class="pp-pp__space-card">' +
      '<h3 class="pp-pp__panel-title">' + esc(t('ui.space.films.title')) + '</h3>' +
      '<p class="pp-pp__panel-note">' + esc(t('ui.space.films.lede', { n: n })) + '</p>' +
      filmHTML('long', 'ui.space.films.long', 'ui.space.films.longNote', false) +
      filmHTML('reel', 'ui.space.films.reel', 'ui.space.films.reelNote', true) +
    '</div>';
  }
  function tabPrices() {
    var g = geoPack();
    if (!g) return '<div class="pp-pp__card"><p>' + esc(t('ui.med.ask', { email: CFG.contactEmail })) + '</p></div>';
    var bullets = function (arr) { return '<ul class="pp-pp__space-list">' + (arr || []).map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>'; };
    var chips = (g.marketplaces || []).map(function (m) { return '<span class="pp-pp__chip is-static">' + esc(m) + '</span>'; }).join('');
    return '<div class="pp-pp__space-card">' +
      '<h3 class="pp-pp__panel-title">' + esc(g.title || '') + '</h3>' +
      '<p class="pp-pp__panel-note">' + esc(g.statement || '') + '</p>' +
      '<div class="pp-pp__status pp-pp__space-prices">' +
        '<div class="pp-pp__card">' + priceTableHTML(g) + '</div>' +
        '<div class="pp-pp__card"><h3>' + esc(t('ui.space.prices.guidelines')) + '</h3>' + bullets(g.guidelines) +
          (chips ? '<h4 class="pp-pp__space-h4">' + esc(t('ui.space.prices.marketplaces')) + '</h4><div class="pp-pp__chips">' + chips + '</div>' : '') +
        '</div>' +
      '</div>' +
      '<div class="pp-pp__card"><h3>' + esc(t('ui.space.prices.compliance')) + '</h3>' + bullets(g.compliance) + '</div>' +
    '</div>';
  }
  function docCard(title, note, href, act) {
    return '<div class="pp-pp__card pp-pp__space-doc"><div><h3>' + esc(title) + '</h3><p>' + esc(note || '') + '</p></div>' +
      '<div class="pp-pp__tile-act">' + (href
        ? '<a class="pp-pp__btn" href="' + esc(href) + '" target="_blank" rel="noopener">' + esc(t('ui.med.openDoc')) + '</a>'
        : '<button class="pp-pp__btn" type="button" ' + act + '>' + esc(t('ui.med.open')) + '</button>') + '</div></div>';
  }
  function tabDocs() {
    var D = CFG.docs || {};
    return '<div class="pp-pp__space-card">' +
      '<h3 class="pp-pp__panel-title">' + esc(t('ui.space.docs.title')) + '</h3>' +
      '<p class="pp-pp__panel-note">' + esc(t('ui.space.docs.lede')) + '</p>' +
      '<div class="pp-pp__space-docs">' +
        (D.cgv ? docCard(t('ui.space.docs.cgv'), t('ui.space.docs.cgvNote'), D.cgv) : '') +
        (D.fda ? docCard(t('ui.space.docs.fda'), '', D.fda) : '') +
        (MCFG.enabled ? docCard(t('ui.space.docs.sds'), t('ui.space.docs.sdsNote'), '', 'data-space-media="inci"') : '') +
        docCard(t('ui.space.docs.training'), t('ui.space.training.lede'), '', 'data-space-tab="training"') +
      '</div>' +
    '</div>';
  }
  /* ---- shipping file (inside the client space, before anything else opens) ---- */
  function shipReviewHTML() {
    var D = shipRec().data;
    var out = '<h3>' + esc(t('ui.ship.review.title')) + '</h3><p class="pp-pp__panel-note">' + esc(t('ui.ship.review.lede')) + '</p>';
    SHIP.forEach(function (s, ix) {
      var rows = '';
      allFields(s).forEach(function (f) {
        var v = D[f.k];
        if (f.type === 'check') { if (!v) return; v = '✓'; }
        if (isBlank(v)) return;
        if (f.type === 'country') v = countryName(v);
        rows += '<dt>' + esc(ts('sf.' + f.k + '.l', f.label)) + '</dt><dd>' + esc(v) + '</dd>';
      });
      (s.terms || []).forEach(function (tm) {
        rows += '<dt>' + esc(ts('st.' + tm.k + '.t', tm.title)) + '</dt><dd>' + (D[tm.k] ? '✓' : '—') + '</dd>';
      });
      if (!rows) return;
      out += '<div class="pp-pp__review-group"><h4>' + esc(ts('sh.' + s.id + '.t', s.title)) +
             ' <button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-sgoto="' + ix + '">' + esc(t('ui.review.edit')) + '</button></h4>' +
             '<dl>' + rows + '</dl></div>';
    });
    return out;
  }
  function screenShip() {
    var r = shipRec(), c = ST.client || {};
    var i = Math.min(r.step | 0, SHIP.length - 1), step = SHIP[i];
    var nav = SHIP.map(function (s, ix) {
      var done = validateShip(ix).length === 0;
      return '<button class="pp-pp__step' + (ix === i ? ' is-active' : '') + (done && ix !== i ? ' is-done' : '') +
        '" type="button" data-sgoto="' + ix + '"><span>' + ('0' + (ix + 1)).slice(-2) + '</span>' + esc(ts('sh.' + s.id + '.nav', s.nav)) + '</button>';
    }).join('');
    var body = '';
    if (step.terms) {
      body += '<ul class="pp-pp__terms">' + step.terms.map(function (tm) {
        return '<li><label class="pp-pp__check" data-field="' + tm.k + '">' +
          '<input type="checkbox" data-k="' + tm.k + '" data-ns="ship"' + (r.data[tm.k] ? ' checked' : '') + '>' +
          '<span><b>' + esc(ts('st.' + tm.k + '.t', tm.title)) + '.</b> ' + esc(ts('st.' + tm.k + '.b', tm.body, TERMVARS)) + '</span>' +
        '</label></li>';
      }).join('') + '</ul>';
    }
    body += '<div class="pp-pp__grid">' + allFields(step).map(function (f) { return fieldHTML(f, 'ship'); }).join('') + '</div>';
    if (step.regime) body += '<div data-regime-slot>' + regimeHTML(r.data.country) + '</div>';
    if (i === SHIP.length - 1) body += '<div class="pp-pp__review" data-review>' + shipReviewHTML() + '</div>';

    return '<header class="pp-pp__masthead pp-pp__space-head">' +
        '<p class="pp-pp__eyebrow">' + esc(t('ui.ship.eyebrow')) + '</p>' +
        '<h1 class="pp-pp__title">' + esc(t('ui.ship.title')) + '</h1>' +
        '<p class="pp-pp__lede">' + esc(t('ui.ship.lede')) + '</p>' +
        '<div class="pp-pp__space-meta">' +
          '<span class="pp-pp__space-status"><i></i>' + esc(c.name || '') + '</span>' +
          (c.ref ? '<span class="pp-pp__mono">' + esc(t('ui.ship.order', { ref: c.ref, date: fmtDate(c.date) })) + '</span>' : '') +
        '</div>' +
      '</header>' +
      '<nav class="pp-pp__steps" aria-label="' + esc(t('ui.ship.title')) + '">' + nav + '</nav>' +
      '<p class="pp-pp__missing" data-missing role="alert" hidden></p>' +
      '<fieldset class="pp-pp__panel">' +
        '<legend class="pp-pp__panel-title">' + esc(ts('sh.' + step.id + '.t', step.title)) + '</legend>' +
        '<p class="pp-pp__panel-note">' + esc(ts('sh.' + step.id + '.n', step.note)) + '</p>' +
        body +
      '</fieldset>' +
      '<div class="pp-pp__nav">' +
        '<button class="pp-pp__btn" type="button" data-sprev' + (i === 0 ? ' hidden' : '') + '>' + esc(t('ui.back')) + '</button>' +
        '<span class="pp-pp__nav-count">' + esc(t('ui.count', { n: i + 1, total: SHIP.length })) + '</span>' +
        (i < SHIP.length - 1
          ? '<button class="pp-pp__btn pp-pp__btn--solid" type="button" data-snext>' + esc(t('ui.continue')) + '</button>' +
            ''
          : '<button class="pp-pp__btn pp-pp__btn--solid" type="button" data-ssend>' + esc(t('ui.ship.submit')) + '</button>') +
      '</div>' +
      '<div class="pp-pp__foot">' +
        '<a href="mailto:' + esc(c.contactEmail || CFG.contactEmail) + '">' + esc(c.contactEmail || CFG.contactEmail) + '</a>' +
        '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-space-close>' + esc(t('ui.space.close')) + '</button>' +
        '<span class="pp-pp__saved" data-saved></span></div>';
  }
  function shipBannerHTML() {
    var r = shipRec();
    if (!r.submittedAt) return '';
    var filed = new Date(r.submittedAt);
    var used = businessDaysBetween(filed, new Date());
    var total = CFG.shipSlaDays | 0;
    var over = used > total, track = '';
    for (var i = 0; i < total; i++) track += '<i class="' + (i < used ? 'is-on' : '') + '"></i>';
    var pipe = ['ui.ship.rev.p1', 'ui.ship.rev.p2', 'ui.ship.rev.p3', 'ui.ship.rev.p4', 'ui.ship.rev.p5'].map(function (k, ix) {
      var on = total > 0 ? (ix / 5) * total < used : false;
      return '<li class="' + (on ? 'is-on' : '') + '">' + esc(t(k)) + '</li>';
    }).join('');
    return '<div class="pp-pp__card pp-pp__ship-rev" data-ship-review>' +
        '<h3>' + esc(t('ui.ship.rev.title')) + '</h3>' +
        '<p>' + esc(t('ui.ship.rev.lede', { n: total })) + '</p>' +
      '</div>' +
      '<div class="pp-pp__status">' +
        '<div class="pp-pp__card">' +
          '<h3>' + esc(t('ui.ship.rev.ref')) + '</h3>' +
          '<p class="pp-pp__ref">' + esc(r.ref) + '</p>' +
          '<p class="pp-pp__meta">' + esc(t('ui.ship.rev.filed', { date: filed.toLocaleDateString() })) + ' · ' +
            esc(t('ui.ship.rev.window', { n: total })) + '</p>' +
          '<div class="pp-pp__track">' + track + '</div>' +
          '<p class="pp-pp__meta">' + (over
            ? esc(t('ui.ship.rev.over', { email: (ST.client || {}).contactEmail || CFG.contactEmail }))
            : esc(t('ui.ship.rev.elapsed', { n: Math.min(used + 1, total), total: total }))) + '</p>' +
        '</div>' +
        '<div class="pp-pp__card">' +
          '<h3>' + esc(t('ui.ship.rev.what')) + '</h3>' +
          '<ul class="pp-pp__pipeline">' + pipe + '</ul>' +
        '</div>' +
      '</div>';
  }

  function screenSpace() {
    if (!ST.client) { ST.stage = 'gate'; return screenGate(); }
    if (!shipRec().submittedAt) return screenShip();      /* nothing else opens before the file is filed */
    var tab = ST.spaceTab || 'home', body;
    if (tab === 'training') body = tabTraining();
    else if (tab === 'films') body = tabFilms();
    else if (tab === 'prices') body = tabPrices();
    else if (tab === 'docs') body = tabDocs();
    else body = shipBannerHTML() + tabHome();
    return spaceHeader() + spaceTabs() + body +
      '<div class="pp-pp__foot">' +
        '<a href="mailto:' + esc((ST.client || {}).contactEmail || CFG.contactEmail) + '">' + esc((ST.client || {}).contactEmail || CFG.contactEmail) + '</a>' +
        '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-space-close>' + esc(t('ui.space.close')) + '</button>' +
        '<span class="pp-pp__saved" data-saved></span></div>';
  }

  /* the training module: fetched once, personalised, shown in a sandboxed frame */
  var TRAINING_HTML = null;
  function loadTraining() {
    if (TRAINING_HTML) return Promise.resolve(TRAINING_HTML);
    if (w.PP_TRAINING_HTML) { TRAINING_HTML = w.PP_TRAINING_HTML; return Promise.resolve(TRAINING_HTML); }
    if (!CFG.trainingUrl) return Promise.reject(new Error('no module'));
    return new Promise(function (res, rej) {
      var sc = d.createElement('script');
      sc.src = CFG.trainingUrl; sc.async = true;
      sc.onload = function () { TRAINING_HTML = w.PP_TRAINING_HTML || ''; TRAINING_HTML ? res(TRAINING_HTML) : rej(new Error('empty')); };
      sc.onerror = function () { rej(new Error('load')); };
      d.head.appendChild(sc);
    });
  }
  function trainingDoc(html) {
    var c = ST.client || {}, g = geoPack() || {};
    var fonts = CFG.fonts || {};
    var css = '<style>' +
      (fonts.body ? "@font-face{font-family:'Unica77 LL';src:url(" + fonts.body + ") format('woff2');font-display:swap}" : '') +
      "body{font-family:'Unica77 LL',ui-sans-serif,system-ui,sans-serif}h1,h2,h3,h4{font-family:'Unica77 LL',ui-sans-serif,system-ui,sans-serif;font-weight:400}" +
      '</style>';
    var pricing = g.title ? '<p><strong>' + esc(g.title) + '</strong></p>' + priceTableHTML(g) + '<p>' + esc(g.statement || '') + '</p>' : '';
    var map = {
      CLIENT_NAME: esc(c.name || ''), CLIENT_SHORT: esc(c.name || ''), GEO_LABEL: esc(g.label || c.country || ''),
      CONTACT_NAME: esc(c.contactName || CFG.brand), CONTACT_EMAIL: esc(c.contactEmail || CFG.contactEmail),
      YEAR: String(new Date().getFullYear()), FONT_CSS: css, PRICING_BLOCK: pricing,
      MEDIA_LINK: esc(w.location.pathname + '#media')
    };
    return html.replace(/\{\{([A-Z_]+)\}\}/g, function (m, k) { return k in map ? map[k] : ''; });
  }
  function openTraining(btn) {
    var host = $('[data-training-host]', app), frame = host && $('iframe', host);
    if (!host || !frame) return;
    if (btn) { btn.disabled = true; }
    loadTraining().then(function (html) {
      frame.srcdoc = trainingDoc(html);
      host.hidden = false;
      var pr = $('[data-training-print]', app); if (pr) pr.hidden = false;
      if (btn) { btn.disabled = false; btn.hidden = true; }
      host.scrollIntoView({ block: 'start', behavior: 'smooth' });
    })['catch'](function () {
      if (btn) { btn.disabled = false; }
      w.open('mailto:' + CFG.contactEmail, '_self');
    });
  }
  function printTraining() {
    var frame = $('[data-training-host] iframe', app);
    if (!frame || !TRAINING_HTML) return;
    var blob = new Blob([trainingDoc(TRAINING_HTML)], { type: 'text/html;charset=utf-8' });
    var u = w.URL.createObjectURL(blob);
    w.open(u, '_blank', 'noopener');
    setTimeout(function () { w.URL.revokeObjectURL(u); }, 30000);
  }
  function setSubLang(which, code) {
    ST.subLang = code; save();
    var v = $('video[data-film="' + which + '"]', app);
    if (!v || !v.textTracks) return;
    for (var i = 0; i < v.textTracks.length; i++) v.textTracks[i].mode = (v.textTracks[i].language === code) ? 'showing' : 'disabled';
  }

  /* ------------------------------------------------------------------ SCREENS */
  var app = $('[data-pp-app]', root);
  var boot = $('[data-pp-boot]', root);

  function shellFoot() {
    return '<div class="pp-pp__foot">' +
      '<a href="mailto:' + esc(CFG.contactEmail) + '">' + esc(CFG.contactEmail) + '</a>' +
      '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-print>' + esc(t('ui.print')) + '</button>' +
      '<button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-reset>' + esc(t('ui.reset')) + '</button>' +
      '<span class="pp-pp__saved" data-saved></span></div>';
  }

  /* ---- gate ---- */
  function screenGate() {
    return '<div class="pp-pp__gate">' +
      '<p class="pp-pp__eyebrow">' + esc(t('ui.eyebrow')) + '</p>' +
      '<h1 class="pp-pp__gate-title">' + esc(CFG.gateTitle || t('ui.gate.title')) + '</h1>' +
      '<p class="pp-pp__gate-lede">' + esc(CFG.gateLede || t(CL.count ? 'ui.gate.lede2' : 'ui.gate.lede')) + '</p>' +
      '<form class="pp-pp__gate-form" data-gate novalidate>' +
        '<label class="pp-pp__sr" for="pp-gate-in">' + esc(t(CL.count ? 'ui.gate.ph2' : 'ui.gate.ph')) + '</label>' +
        '<input class="pp-pp__gate-input" id="pp-gate-in" type="text" autocomplete="off" spellcheck="false" autocapitalize="characters" ' +
          'placeholder="' + esc(t(CL.count ? 'ui.gate.ph2' : 'ui.gate.ph')) + '" aria-describedby="pp-gate-err">' +
        '<button class="pp-pp__btn pp-pp__btn--solid" type="submit">' + esc(t('ui.gate.cta')) + '</button>' +
      '</form>' +
      '<p class="pp-pp__gate-error" id="pp-gate-err" data-gate-err role="alert" hidden>' + esc(t(CL.count ? 'ui.gate.err2' : 'ui.gate.err')) + '</p>' +
      '<p class="pp-pp__gate-foot">' + t('ui.gate.foot', { email: '<a href="mailto:' + esc(CFG.contactEmail) + '">' + esc(CFG.contactEmail) + '</a>' }) + '</p>' +
    '</div>';
  }

  /* ---- apply ---- */
  function screenApply() {
    var i = Math.min(ST.step, STEPS.length - 1), step = STEPS[i];
    var nav = STEPS.map(function (s, ix) {
      var done = validateStep(ix).length === 0;
      return '<button class="pp-pp__step' + (ix === i ? ' is-active' : '') + (done && ix !== i ? ' is-done' : '') +
        '" type="button" data-goto="' + ix + '"><span>' + ('0' + (ix + 1)).slice(-2) + '</span>' + esc(ts('s.' + s.id + '.nav', s.nav)) + '</button>';
    }).join('');

    var body = '';
    if (step.terms) {
      body += '<ul class="pp-pp__terms">' + step.terms.map(function (tm) {
        return '<li><label class="pp-pp__check" data-field="' + tm.k + '">' +
          '<input type="checkbox" data-k="' + tm.k + '" data-ns="data"' + (ST.data[tm.k] ? ' checked' : '') + '>' +
          '<span><b>' + esc(ts('t.' + tm.k + '.t', tm.title)) + '.</b> ' + esc(ts('t.' + tm.k + '.b', tm.body, TERMVARS)) + '</span>' +
        '</label></li>';
      }).join('') + '</ul>';
    }
    body += '<div class="pp-pp__grid">' + allFields(step).map(function (f) { return fieldHTML(f, 'data'); }).join('') + '</div>';
    if (step.regime) body += '<div data-regime-slot>' + regimeHTML(ST.data.country) + '</div>';
    if (i === STEPS.length - 1) body += '<div class="pp-pp__review" data-review>' + reviewHTML() + '</div>';

    return '<header class="pp-pp__masthead">' +
        '<p class="pp-pp__eyebrow">' + esc(t('ui.stage1')) + '</p>' +
        '<h1 class="pp-pp__title">' + esc(t('ui.apply.title')) + '</h1>' +
        '<p class="pp-pp__lede">' + esc(t('ui.apply.lede')) + '</p>' +
      '</header>' +
      '<nav class="pp-pp__steps" aria-label="' + esc(t('ui.apply.title')) + '">' + nav + '</nav>' +
      '<p class="pp-pp__missing" data-missing role="alert" hidden></p>' +
      '<fieldset class="pp-pp__panel">' +
        '<legend class="pp-pp__panel-title">' + esc(ts('s.' + step.id + '.t', step.title)) + '</legend>' +
        '<p class="pp-pp__panel-note">' + esc(ts('s.' + step.id + '.n', step.note)) + '</p>' +
        body +
      '</fieldset>' +
      '<div class="pp-pp__nav">' +
        '<button class="pp-pp__btn" type="button" data-prev' + (i === 0 ? ' hidden' : '') + '>' + esc(t('ui.back')) + '</button>' +
        '<span class="pp-pp__nav-count">' + esc(t('ui.count', { n: i + 1, total: STEPS.length })) + '</span>' +
        (i < STEPS.length - 1
          ? '<button class="pp-pp__btn pp-pp__btn--solid" type="button" data-next>' + esc(t('ui.continue')) + '</button>'
          : '<button class="pp-pp__btn pp-pp__btn--solid" type="button" data-send>' + esc(t('ui.submit')) + '</button>') +
      '</div>' + shellFoot();
  }

  function regimeHTML(code) {
    var r = regimeFor(code);
    if (!r) return '';
    var docs = (r.docsFromBrand || []).map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('');
    return '<div class="pp-pp__regime">' +
      '<h4>' + esc(r.label) + '</h4>' +
      '<p class="pp-pp__regime-auth">' + esc(r.authority) + '</p>' +
      '<dl>' +
        '<dt>Before first sale</dt><dd>' + esc(r.registration) + '</dd>' +
        '<dt>Established locally</dt><dd>' + esc(r.responsiblePerson) + '</dd>' +
        '<dt>Labelling</dt><dd>' + esc(r.labelling) + '</dd>' +
        '<dt>We issue you</dt><dd><ul style="margin:0;padding-inline-start:18px">' + docs + '</ul></dd>' +
      '</dl>' +
      (r.gotcha ? '<p class="pp-pp__gotcha"><b>Most often got wrong.</b> ' + esc(r.gotcha) + '</p>' : '') +
    '</div>';
  }

  function tradeHTML() {
    if (!TRADE || !TRADE.documents) return '';
    var dg = TRADE.dangerousGoods || {}, hs = TRADE.hsCode || {};
    var inco = (TRADE.incoterms || []).map(function (i) {
      return '<dt>' + esc(i.code) + '</dt><dd>' + esc(i.plain) + '</dd>';
    }).join('');
    var docs = (TRADE.documents || []).map(function (x) {
      return '<tr><td class="nm">' + esc(x.name) + '</td><td>' + esc(x.who) + '</td><td>' + esc(x.when) + '</td></tr>';
    }).join('');
    return '<div class="pp-pp__regime" style="margin-top:26px">' +
        '<h4>' + esc(t('ui.tr.dg')) + '</h4>' +
        '<p class="pp-pp__regime-auth">' + esc(dg.unNumber || '') + ' · ' + esc(dg.properShippingName || '') + '</p>' +
        '<dl>' +
          '<dt>' + esc(t('ui.tr.class')) + '</dt><dd>' + esc(dg.class || '') + ' · ' + esc(t('ui.tr.pg')) + ' ' + esc(dg.packingGroup || '') + '</dd>' +
          '<dt>' + esc(t('ui.tr.air')) + '</dt><dd>' + esc(dg.airNote || '') + '</dd>' +
          '<dt>' + esc(t('ui.tr.sea')) + '</dt><dd>' + esc(dg.seaNote || '') + '</dd>' +
          '<dt>' + esc(t('ui.tr.lq')) + '</dt><dd>' + esc(dg.exemptions || '') + '</dd>' +
          '<dt>' + esc(t('ui.tr.hs')) + '</dt><dd>' + esc(hs.code || '') + ' — ' + esc(hs.description || '') + ' ' + esc(hs.note || '') + '</dd>' +
        '</dl>' +
      '</div>' +
      '<div class="pp-pp__regime" style="margin-top:20px">' +
        '<h4>' + esc(t('ui.tr.inco')) + '</h4><dl>' + inco + '</dl>' +
      '</div>' +
      '<h4 style="font-family:var(--pp-body);font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:var(--pp-dim);margin:30px 0 12px">' +
        esc(t('ui.tr.docs')) + '</h4>' +
      '<div class="pp-pp__plan"><table><thead><tr>' +
        '<th>' + esc(t('ui.tr.doc')) + '</th><th>' + esc(t('ui.tr.who')) + '</th><th>' + esc(t('ui.tr.when')) + '</th>' +
      '</tr></thead><tbody>' + docs + '</tbody></table></div>';
  }

  function reviewHTML() {
    var out = '<h3>' + esc(t('ui.review.title')) + '</h3>';
    STEPS.forEach(function (s, ix) {
      var rows = '';
      allFields(s).forEach(function (f) {
        var v = ST.data[f.k];
        if (isBlank(v)) return;
        if (f.type === 'country') v = countryName(v);
        rows += '<dt>' + esc(ts('f.' + f.k + '.l', f.label)) + '</dt><dd>' + esc(v) + '</dd>';
      });
      (s.terms || []).forEach(function (tm) {
        rows += '<dt>' + esc(ts('t.' + tm.k + '.t', tm.title)) + '</dt><dd>' + (ST.data[tm.k] ? '✓' : '—') + '</dd>';
      });
      if (!rows) return;
      out += '<div class="pp-pp__review-group"><h4>' + esc(ts('s.' + s.id + '.t', s.title)) +
             ' <button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-goto="' + ix + '">' + esc(t('ui.review.edit')) + '</button></h4>' +
             '<dl>' + rows + '</dl></div>';
    });
    return out;
  }

  /* ---- review (stage 2) ---- */
  function screenReview() {
    var filed = ST.submittedAt ? new Date(ST.submittedAt) : new Date();
    var used = businessDaysBetween(filed, new Date());
    var total = CFG.slaDays | 0;
    var over = used > total;
    var track = '';
    for (var i = 0; i < total; i++) track += '<i class="' + (i < used ? 'is-on' : '') + '"></i>';
    var pipe = ['ui.rev.p1', 'ui.rev.p2', 'ui.rev.p3', 'ui.rev.p4', 'ui.rev.p5'].map(function (k, ix) {
      var on = total > 0 ? (ix / 5) * total < used : false;
      return '<li class="' + (on ? 'is-on' : '') + '">' + esc(t(k)) + '</li>';
    }).join('');

    var doneCount = ['t1', 't2', 't3', 't4'].filter(function (k) { return ST.tasks[k]; }).length;

    return '<header class="pp-pp__masthead">' +
        '<p class="pp-pp__eyebrow">' + esc(t('ui.stage2')) + '</p>' +
        '<h1 class="pp-pp__title">' + esc(t('ui.rev.title')) + '</h1>' +
        '<p class="pp-pp__lede">' + esc(t('ui.rev.lede', { n: total })) + '</p>' +
      '</header>' +
      '<div class="pp-pp__status">' +
        '<div class="pp-pp__card">' +
          '<h3>' + esc(t('ui.rev.ref')) + '</h3>' +
          '<p class="pp-pp__ref">' + esc(ST.ref) + '</p>' +
          '<p class="pp-pp__meta">' + esc(t('ui.rev.filed', { date: filed.toLocaleDateString() })) + ' · ' +
            esc(t('ui.rev.window', { n: total })) + '</p>' +
          '<div class="pp-pp__track">' + track + '</div>' +
          '<p class="pp-pp__meta">' + (over
            ? esc(t('ui.rev.over', { email: CFG.contactEmail }))
            : esc(t('ui.rev.elapsed', { n: Math.min(used + 1, total), total: total }))) + '</p>' +
          '<p class="pp-pp__meta" style="margin-top:14px">' + esc(t('ui.rev.progress', { done: doneCount, total: 4 })) + '</p>' +
        '</div>' +
        '<div class="pp-pp__card">' +
          '<h3>' + esc(t('ui.rev.pipeline')) + '</h3>' +
          '<ul class="pp-pp__pipeline">' + pipe + '</ul>' +
        '</div>' +
      '</div>' +
      '<div class="pp-pp__tasks">' +
        taskHTML('t1', 1, t('ui.t1.title'), t('ui.t1.body', TERMVARS), docsHTML()) +
        taskHTML('t2', 2, t('ui.t2.title'), t('ui.t2.body'),
          (regimeHTML(ST.data.country) || '<p class="pp-pp__hint">' + esc(t('ui.t2.nocountry')) + '</p>') + tradeHTML()) +
        taskHTML('t3', 3, t('ui.t3.title'), t('ui.t3.body', TERMVARS), planHTML()) +
        taskHTML('t4', 4, t('ui.t4.title'), t('ui.t4.body'), launchHTML()) +
      '</div>' +
      '<div class="pp-pp__unlock">' +
        '<div class="pp-pp__unlock-txt"><h3>' + esc(t('ui.unlock.title')) + '</h3><p>' + esc(t('ui.unlock.body')) + '</p></div>' +
        '<form class="pp-pp__unlock-form" data-unlock novalidate>' +
          '<label class="pp-pp__sr" for="pp-unlock-in">' + esc(t('ui.unlock.ph')) + '</label>' +
          '<input id="pp-unlock-in" type="text" autocomplete="off" spellcheck="false" placeholder="' + esc(t('ui.unlock.ph')) + '">' +
          '<button class="pp-pp__btn pp-pp__btn--solid" type="submit">' + esc(t('ui.unlock.cta')) + '</button>' +
        '</form>' +
      '</div>' +
      '<p class="pp-pp__hint is-bad" data-unlock-err hidden>' + esc(t('ui.unlock.err')) + '</p>' +
      shellFoot();
  }

  function taskHTML(k, n, title, body, inner) {
    var done = !!ST.tasks[k], open = ST.openTask === k;
    return '<div class="pp-pp__task' + (done ? ' is-done' : '') + (open ? ' is-open' : '') + '" data-task="' + k + '">' +
      '<button class="pp-pp__task-head" type="button" data-task-toggle="' + k + '" aria-expanded="' + (open ? 'true' : 'false') + '">' +
        '<span class="pp-pp__task-num">' + ('0' + n).slice(-2) + '</span>' +
        '<span class="pp-pp__task-title">' + esc(title) + '</span>' +
        '<span class="pp-pp__task-state">' + esc(done ? t('ui.rev.done') : t('ui.rev.todo')) + '</span>' +
      '</button>' +
      '<div class="pp-pp__task-body"' + (open ? '' : ' hidden') + '>' +
        '<p>' + esc(body) + '</p>' + inner +
        '<div style="margin-top:22px"><button class="pp-pp__btn" type="button" data-task-done="' + k + '">' +
          esc(done ? t('ui.rev.marked') : t('ui.rev.markDone')) + '</button></div>' +
      '</div>' +
    '</div>';
  }

  function docsHTML() {
    return '<ul class="pp-pp__docs">' + DOCS.map(function (dd) {
      return '<li><label class="pp-pp__doc"><input type="checkbox" data-doc="' + dd.k + '"' + (ST.docs[dd.k] ? ' checked' : '') + '>' +
        '<span class="pp-pp__doc-txt"><span class="pp-pp__doc-name">' + esc(ts('d.' + dd.k + '.n', dd.name)) + '</span><br>' +
        '<span class="pp-pp__doc-meta">' + esc(ts('d.' + dd.k + '.m', dd.meta)) + '</span></span></label></li>';
    }).join('') + '</ul>';
  }

  function planHTML() {
    var m = planMath();
    var rows = ROWS.map(function (r) {
      var q = ST.plan[r.sku] || '';
      var isBad = m.bad.some(function (b) { return b.sku === r.sku; });
      var qn = parseInt(q, 10) || 0;
      return '<tr>' +
        '<td class="nm">' + esc(r.name) + '</td>' +
        '<td>' + esc(r.size) + '</td>' +
        '<td class="sku">' + esc(r.sku) + '</td>' +
        '<td class="num"><input class="pp-pp__qty' + (isBad ? ' is-invalid' : '') + '" type="number" min="0" step="' + m.caseSize +
          '" inputmode="numeric" value="' + esc(q) + '" data-plan="' + esc(r.sku) + '" aria-label="' + esc(r.name + ' ' + r.size) + '"></td>' +
        '<td class="num">' + (qn ? Math.ceil(qn / m.caseSize) : '—') + '</td>' +
        '<td class="num">' + (qn ? Math.floor(qn / m.ratio) : '—') + '</td>' +
      '</tr>';
    }).join('');

    var msg = '';
    if (m.bad.length) msg = '<p class="pp-pp__hint is-bad">' + esc(t('ui.plan.caseErr', { case: m.caseSize, sku: m.bad[0].sku, up: m.bad[0].up })) + '</p>';
    else if (!m.moqOk) msg = '<p class="pp-pp__hint is-bad">' + esc(t('ui.plan.moqErr', { moq: CFG.moqUnits, n: m.units })) + '</p>';
    else if (m.units > 0) msg = '<p class="pp-pp__hint">' + esc(t('ui.plan.ok')) + '</p>';

    return '<div class="pp-pp__grid" style="margin-top:18px"><label class="pp-pp__field"><span>' + esc(t('ui.plan.orderType')) + '</span>' +
        '<select data-ordertype>' +
          '<option value="opening"' + (ST.orderType === 'opening' ? ' selected' : '') + '>' + esc(t('ui.plan.opening')) + '</option>' +
          '<option value="reassort"' + (ST.orderType === 'reassort' ? ' selected' : '') + '>' + esc(t('ui.plan.reassort')) + '</option>' +
        '</select></label></div>' +
      '<div class="pp-pp__plan"><table><thead><tr>' +
        '<th>' + esc(t('ui.plan.house')) + '</th><th>' + esc(t('ui.plan.size')) + '</th><th>' + esc(t('ui.plan.sku')) + '</th>' +
        '<th class="num">' + esc(t('ui.plan.units')) + '</th><th class="num">' + esc(t('ui.plan.cases')) + '</th><th class="num">' + esc(t('ui.plan.testers')) + '</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table></div>' +
      '<dl class="pp-pp__tally">' +
        '<div><dt>' + esc(t('ui.plan.totalRefs')) + '</dt><dd>' + m.refs + '</dd></div>' +
        '<div><dt>' + esc(t('ui.plan.totalUnits')) + '</dt><dd class="' + (m.units && m.moqOk ? 'is-ok' : (m.units ? 'is-bad' : '')) + '">' + m.units + '</dd></div>' +
        '<div><dt>' + esc(t('ui.plan.totalCases')) + '</dt><dd>' + m.cases + '</dd></div>' +
        '<div><dt>' + esc(t('ui.plan.totalTest')) + '</dt><dd>' + m.testers + '</dd></div>' +
      '</dl>' + msg +
      '<p class="pp-pp__hint">' + esc(t('ui.plan.note')) + '</p>';
  }

  function launchHTML() {
    return '<div class="pp-pp__grid" style="margin-top:18px">' +
      LAUNCH.map(function (f) { return fieldHTML(f, 'launch'); }).join('') + '</div>';
  }

  /* ---- pack (stage 3) ---- */
  function screenPack() {
    var m = planMath();
    var lines = ROWS.filter(function (r) { return (parseInt(ST.plan[r.sku], 10) || 0) > 0; }).map(function (r) {
      var q = parseInt(ST.plan[r.sku], 10) || 0;
      return '<tr><td class="nm">' + esc(r.name) + '</td><td>' + esc(r.size) + '</td><td class="sku">' + esc(r.sku) + '</td>' +
        '<td class="num">' + q + '</td><td class="num">' + Math.ceil(q / m.caseSize) + '</td><td class="num">' + Math.floor(q / m.ratio) + '</td></tr>';
    }).join('');

    var warn = '';
    if (!m.units) warn = '<p class="pp-pp__hint is-bad">' + esc(t('ui.pack.warnEmpty')) + '</p>';
    else if (m.bad.length) warn = '<p class="pp-pp__hint is-bad">' + esc(t('ui.plan.caseErr', { case: m.caseSize, sku: m.bad[0].sku, up: m.bad[0].up })) + '</p>';
    else if (!m.moqOk) warn = '<p class="pp-pp__hint is-bad">' + esc(t('ui.plan.moqErr', { moq: CFG.moqUnits, n: m.units })) + '</p>';

    return '<header class="pp-pp__masthead">' +
        '<p class="pp-pp__eyebrow">' + esc(t('ui.stage3')) + ' · ' + esc(ST.ref) + '</p>' +
        '<h1 class="pp-pp__title">' + esc(t('ui.pack.title')) + '</h1>' +
        '<p class="pp-pp__lede">' + esc(t('ui.pack.lede')) + '</p>' +
      '</header>' +
      '<h3 style="margin-bottom:14px">' + esc(t('ui.pack.lines')) + '</h3>' +
      '<div class="pp-pp__plan"><table><thead><tr>' +
        '<th>' + esc(t('ui.plan.house')) + '</th><th>' + esc(t('ui.plan.size')) + '</th><th>' + esc(t('ui.plan.sku')) + '</th>' +
        '<th class="num">' + esc(t('ui.plan.units')) + '</th><th class="num">' + esc(t('ui.plan.cases')) + '</th><th class="num">' + esc(t('ui.plan.testers')) + '</th>' +
      '</tr></thead><tbody>' + (lines || '<tr><td colspan="6">' + esc(t('ui.plan.empty')) + '</td></tr>') + '</tbody>' +
      '<tfoot><tr><td class="lbl" colspan="3">' + esc(t('ui.plan.total')) + '</td>' +
        '<td class="num">' + m.units + '</td><td class="num">' + m.cases + '</td><td class="num">' + m.testers + '</td></tr></tfoot></table></div>' +
      warn +
      '<p style="margin-top:10px"><button class="pp-pp__btn pp-pp__btn--ghost" type="button" data-back-plan>' + esc(t('ui.pack.editPlan')) + '</button></p>' +
      '<h3 style="margin:34px 0 14px">' + esc(t('ui.pack.ship')) + '</h3>' +
      '<p class="pp-pp__missing" data-missing role="alert" hidden></p>' +
      '<div class="pp-pp__grid">' + PACK.map(function (f) { return fieldHTML(f, 'pack'); }).join('') + '</div>' +
      '<div class="pp-pp__nav">' +
        '<span class="pp-pp__nav-count">' + esc(ST.ref) + '</span>' +
        '<button class="pp-pp__btn pp-pp__btn--solid" type="button" data-confirm>' + esc(t('ui.pack.submit')) + '</button>' +
      '</div>' + shellFoot();
  }

  /* ---- done ---- */
  function screenDone() {
    return '<div class="pp-pp__done">' +
      '<div class="pp-pp__done-mark">✓</div>' +
      '<h1>' + esc(t('ui.done.title')) + '</h1>' +
      '<p>' + esc(t('ui.done.lede')) + '</p>' +
      '<p>' + esc(t('ui.done.next')) + '</p>' +
      '<p class="pp-pp__ref">' + esc(t('ui.done.ref')) + ' ' + esc(ST.ref) + '</p>' +
    '</div>' + shellFoot();
  }

  /* ------------------------------------------------------------------ render */
  function render() {
    var html;
    if (ST.stage === 'gate') html = screenGate();
    else if (ST.stage === 'space') html = screenSpace();
    else if (ST.stage === 'media') html = screenMedia();
    else if (ST.stage === 'apply') html = screenApply();
    else if (ST.stage === 'review') html = screenReview();
    else if (ST.stage === 'pack') html = screenPack();
    else html = screenDone();
    app.innerHTML = topBar() + html;
    if (boot) boot.hidden = true;
    app.hidden = false;
    var badge = $('[data-saved]', app);
    if (badge && ST.stage !== 'gate') badge.textContent = t('ui.saved');
  }

  /* ------------------------------------------------------------------ payload */
  function buildBody(kind) {
    var L = [];
    L.push('PREMIÈRE PEAU — PARTNER PORTAL');
    L.push(kind === 'pack' ? 'PACKING LIST CONFIRMATION' : 'DISTRIBUTOR APPLICATION');
    L.push('Reference: ' + ST.ref);
    L.push('Filed: ' + (ST.submittedAt || new Date().toISOString()));
    L.push('Locale: ' + CFG.locale);
    L.push('');

    STEPS.forEach(function (s) {
      var lines = [];
      allFields(s).forEach(function (f) {
        var v = ST.data[f.k];
        if (isBlank(v)) return;
        if (f.type === 'country') v = countryName(v) + ' (' + v + ')';
        lines.push('  ' + f.label + ': ' + String(v).replace(/\n/g, '\n      '));
      });
      (s.terms || []).forEach(function (tm) {
        lines.push('  [' + (ST.data[tm.k] ? 'x' : ' ') + '] ' + tm.title);
      });
      if (lines.length) { L.push('— ' + s.title.toUpperCase()); L.push(lines.join('\n')); L.push(''); }
    });

    var reg = regimeFor(ST.data.country);
    if (reg) { L.push('— REGULATORY ROUTE'); L.push('  ' + reg.label + ' — ' + reg.authority); L.push(''); }

    var m = planMath();
    if (m.units) {
      L.push('— ASSORTMENT (' + (ST.orderType === 'reassort' ? 'REASSORT' : 'OPENING') + ')');
      ROWS.forEach(function (r) {
        var q = parseInt(ST.plan[r.sku], 10) || 0;
        if (!q) return;
        L.push('  ' + r.sku + '  ' + r.name + ' ' + r.size + '  units ' + q +
               '  cases ' + Math.ceil(q / m.caseSize) + '  testers ' + Math.floor(q / m.ratio));
      });
      L.push('  TOTAL units ' + m.units + '  cases ' + m.cases + '  references ' + m.refs + '  testers ' + m.testers);
      L.push('  Case size ' + m.caseSize + '  tester ratio 1/' + m.ratio + '  MOQ met: ' + (m.moqOk ? 'yes' : 'NO'));
      L.push('');
    }

    var docsDone = DOCS.filter(function (x) { return ST.docs[x.k]; });
    if (docsDone.length) {
      L.push('— DOCUMENTS THE APPLICANT MARKED SENT');
      docsDone.forEach(function (x) { L.push('  [x] ' + x.name); });
      L.push('');
    }

    var lk = LAUNCH.filter(function (f) { return !isBlank(ST.launch[f.k]); });
    if (lk.length) {
      L.push('— LAUNCH PLAN');
      lk.forEach(function (f) { L.push('  ' + f.label + ': ' + String(ST.launch[f.k]).replace(/\n/g, '\n      ')); });
      L.push('');
    }

    if (kind === 'pack') {
      L.push('— PACKING LIST');
      PACK.forEach(function (f) {
        var v = ST.pack[f.k];
        if (isBlank(v)) return;
        if (f.type === 'country') v = countryName(v) + ' (' + v + ')';
        L.push('  ' + f.label + ': ' + String(v).replace(/\n/g, '\n      '));
      });
      L.push('  Confirmed at: ' + new Date().toISOString());
      L.push('');
    }
    return L.join('\n');
  }

  function buildShipBody() {
    var r = shipRec(), c = ST.client || {}, D = r.data, L = [];
    L.push('PREMIÈRE PEAU — PARTNER SPACE');
    L.push('SHIPPING FILE');
    L.push('Client: ' + (c.name || '') + ' (' + (c.slug || '') + ')');
    L.push('Order: ' + (c.ref || '') + ' · ' + (c.date || ''));
    L.push('Reference: ' + r.ref);
    L.push('Filed: ' + (r.submittedAt || new Date().toISOString()));
    L.push('Locale: ' + CFG.locale);
    L.push('');
    SHIP.forEach(function (s) {
      var lines = [];
      allFields(s).forEach(function (f) {
        var v = D[f.k];
        if (f.type === 'check') { lines.push('  [' + (v ? 'x' : ' ') + '] ' + f.label); return; }
        if (isBlank(v)) return;
        if (f.type === 'country') v = countryName(v) + ' (' + v + ')';
        lines.push('  ' + f.label + ': ' + String(v).replace(/\n/g, '\n      '));
      });
      (s.terms || []).forEach(function (tm) { lines.push('  [' + (D[tm.k] ? 'x' : ' ') + '] ' + tm.title); });
      if (lines.length) { L.push('— ' + s.title.toUpperCase()); L.push(lines.join('\n')); L.push(''); }
    });
    var reg = regimeFor(D.country);
    if (reg) { L.push('— REGULATORY ROUTE'); L.push('  ' + reg.label + ' — ' + reg.authority); L.push(''); }
    return L.join('\n');
  }

  function submitForm(kind) {
    var form = d.getElementById(kind === 'pack' ? 'pp-confirm-form' : (kind === 'ship' ? 'pp-ship-form' : 'pp-apply-form'));
    if (!form) { alert('Form unavailable. Write to ' + CFG.contactEmail); return; }
    if (kind === 'ship') {
      var sr = shipRec(), sc = ST.client || {};
      if (!sr.ref) sr.ref = makeRef();
      var smap = {
        _name: (sr.data.sig_name || '') + ' — ' + (sc.name || ''),
        _reference: sr.ref,
        _client: (sc.name || '') + ' (' + (sc.slug || '') + ')',
        _order: sc.ref || '',
        _country_name: countryName(sr.data.ship_country) + ' (' + (sr.data.ship_country || '') + ')',
        _body: buildShipBody()
      };
      $$('[data-h]', form).forEach(function (inp) {
        var k = inp.getAttribute('data-h');
        inp.value = (k in smap) ? smap[k] : (sr.data[k] != null ? String(sr.data[k]) : '');
      });
      try { w.localStorage.setItem(PENDING, 'ship'); } catch (e) {}
      save();
      form.submit();
      return;
    }
    if (!ST.ref) ST.ref = makeRef();
    var m = planMath();
    var map = {
      _name: (ST.data.buyer_name || '') + ' — ' + (ST.data.legal_name || ''),
      _reference: ST.ref,
      _country_name: countryName(ST.data.country) + ' (' + (ST.data.country || '') + ')',
      _regime_label: (regimeFor(ST.data.country) || {}).label || '',
      _total_units: String(m.units),
      _body: buildBody(kind)
    };
    $$('[data-h]', form).forEach(function (inp) {
      var k = inp.getAttribute('data-h');
      inp.value = (k in map) ? map[k] : (ST.data[k] != null ? String(ST.data[k]) : (ST.pack[k] != null ? String(ST.pack[k]) : ''));
    });
    try { w.localStorage.setItem(PENDING, kind === 'pack' ? 'pack' : 'apply'); } catch (e) {}
    save();
    form.submit();
  }

  /* ------------------------------------------------------------------ events */
  function setVal(ns, k, v) {
    bucket(ns)[k] = v;
    save();
  }

  root.addEventListener('input', function (e) {
    var el2 = e.target;
    if (el2.matches('[data-k]')) {
      setVal(el2.getAttribute('data-ns'), el2.getAttribute('data-k'),
             el2.type === 'checkbox' ? el2.checked : el2.value);
      var wrap = el2.closest('[data-field]');
      if (wrap) {
        wrap.classList.remove('is-invalid');
        var why = $('[data-ferr]', wrap);
        if (why) { why.textContent = ''; why.hidden = true; }
      }
    } else if (el2.matches('[data-plan]')) {
      var sku = el2.getAttribute('data-plan');
      var n = parseInt(el2.value, 10);
      if (isNaN(n) || n < 0) delete ST.plan[sku]; else ST.plan[sku] = n;
      save();
      refreshPlan();
    }
  });

  root.addEventListener('change', function (e) {
    var el2 = e.target;
    if (el2.matches('[data-sub-lang]')) { setSubLang(el2.getAttribute('data-sub-lang'), el2.value); return; }
    if (el2.matches('[data-k]')) {
      setVal(el2.getAttribute('data-ns'), el2.getAttribute('data-k'),
             el2.type === 'checkbox' ? el2.checked : el2.value);
      if (el2.getAttribute('data-k') === 'country') render();
    } else if (el2.matches('[data-doc]')) {
      ST.docs[el2.getAttribute('data-doc')] = el2.checked; save();
    } else if (el2.matches('[data-ordertype]')) {
      ST.orderType = el2.value; save(); refreshPlan();
    }
  });

  function refreshPlan() {
    var host = $('[data-task="t3"] .pp-pp__task-body', app);
    if (!host) return;
    var focusSku = d.activeElement && d.activeElement.getAttribute ? d.activeElement.getAttribute('data-plan') : null;
    var selStart = d.activeElement && d.activeElement.selectionStart;
    host.innerHTML = '<p>' + esc(t('ui.t3.body', TERMVARS)) + '</p>' + planHTML() +
      '<div style="margin-top:22px"><button class="pp-pp__btn" type="button" data-task-done="t3">' +
      esc(ST.tasks.t3 ? t('ui.rev.marked') : t('ui.rev.markDone')) + '</button></div>';
    if (focusSku) {
      var again = $('[data-plan="' + focusSku.replace(/"/g, '\\"') + '"]', host);
      if (again) { again.focus(); try { again.setSelectionRange(selStart, selStart); } catch (e) {} }
    }
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || !root.contains(b)) return;

    if (b.hasAttribute('data-next')) {
      e.preventDefault();
      var miss = validateStep(ST.step);
      if (miss.length) { flagMissing(miss); return; }
      ST.step = Math.min(ST.step + 1, STEPS.length - 1); save(); render(); scrollTop();
    } else if (b.hasAttribute('data-prev')) {
      e.preventDefault(); ST.step = Math.max(0, ST.step - 1); save(); render(); scrollTop();
    } else if (b.hasAttribute('data-goto')) {
      e.preventDefault(); ST.step = parseInt(b.getAttribute('data-goto'), 10) || 0; save(); render(); scrollTop();
    } else if (b.hasAttribute('data-send')) {
      e.preventDefault();
      var bad = firstIncompleteStep();
      if (bad > -1) { ST.step = bad; save(); render(); scrollTop(); flagMissing(validateStep(bad)); return; }
      b.disabled = true; b.textContent = t('ui.sending');
      submitForm('apply');
    } else if (b.hasAttribute('data-snext')) {
      e.preventDefault();
      var sr1 = shipRec(), smiss = validateShip(sr1.step | 0);
      if (smiss.length) { flagMissing(smiss); return; }
      sr1.step = Math.min((sr1.step | 0) + 1, SHIP.length - 1); save(); render(); scrollTop();
    } else if (b.hasAttribute('data-sprev')) {
      e.preventDefault(); var sr2 = shipRec(); sr2.step = Math.max(0, (sr2.step | 0) - 1); save(); render(); scrollTop();
    } else if (b.hasAttribute('data-sgoto')) {
      e.preventDefault(); shipRec().step = parseInt(b.getAttribute('data-sgoto'), 10) || 0; save(); render(); scrollTop();
    } else if (b.hasAttribute('data-ssend')) {
      e.preventDefault();
      var sr3 = shipRec(), sbad = firstIncompleteIn(SHIP, sr3.data);
      if (sbad > -1) { sr3.step = sbad; save(); render(); scrollTop(); flagMissing(validateShip(sbad)); return; }
      b.disabled = true; b.textContent = t('ui.sending');
      submitForm('ship');
    } else if (b.hasAttribute('data-task-toggle')) {
      e.preventDefault();
      var k = b.getAttribute('data-task-toggle');
      ST.openTask = ST.openTask === k ? '' : k; save(); render();
      var node = $('[data-task="' + ST.openTask + '"]', app);
      if (node) node.scrollIntoView({ block: 'start', behavior: 'smooth' });
    } else if (b.hasAttribute('data-task-done')) {
      e.preventDefault();
      var tk = b.getAttribute('data-task-done');
      ST.tasks[tk] = !ST.tasks[tk]; save(); render();
    } else if (b.hasAttribute('data-back-plan')) {
      e.preventDefault(); ST.stage = 'review'; ST.openTask = 't3'; save(); render(); scrollTop();
    } else if (b.hasAttribute('data-confirm')) {
      e.preventDefault();
      var pm = planMath();
      if (!pm.units || pm.bad.length || !pm.moqOk) { scrollTop(); return; }
      var pmiss = PACK.filter(function (f) { return f.req && isBlank(ST.pack[f.k]); }).map(function (f) { return f.k; });
      if (pmiss.length) { flagMissing(pmiss); return; }
      b.disabled = true; b.textContent = t('ui.sending');
      submitForm('pack');
    } else if (b.hasAttribute('data-med-open')) {
      e.preventDefault();
      if (ST.stage !== 'media') ST.backStage = ST.stage;
      ST.stage = 'media'; save(); render(); scrollTop();
    } else if (b.hasAttribute('data-med-back')) {
      e.preventDefault();
      ST.stage = ST.client ? 'space' : (ST.backStage || (ST.confirmedAt ? 'done' : (ST.submittedAt ? (ST.unlocked ? 'pack' : 'review') : (ST.data && Object.keys(ST.data).length ? 'apply' : 'gate'))));
      save(); render(); scrollTop();
    } else if (b.hasAttribute('data-space-tab')) {
      e.preventDefault();
      var tb = b.getAttribute('data-space-tab');
      if (tb === 'media') { ST.backStage = 'space'; ST.stage = 'media'; }
      else { ST.stage = 'space'; ST.spaceTab = tb; }
      save(); render(); scrollTop();
    } else if (b.hasAttribute('data-space-media')) {
      e.preventDefault();
      ST.medGroup = b.getAttribute('data-space-media') || 'inci'; ST.medScent = ''; ST.medKind = ''; ST.medQuery = '';
      ST.backStage = 'space'; ST.stage = 'media'; save(); render(); scrollTop();
    } else if (b.hasAttribute('data-space-close')) {
      e.preventDefault();
      ST.client = null; ST.spaceTab = 'home'; ST.stage = 'gate'; save(); render(); scrollTop();
    } else if (b.hasAttribute('data-training-open')) {
      e.preventDefault(); openTraining(b);
    } else if (b.hasAttribute('data-training-print')) {
      e.preventDefault(); printTraining();
    } else if (b.hasAttribute('data-med-group')) {
      e.preventDefault();
      ST.medGroup = b.getAttribute('data-med-group'); ST.medScent = ''; ST.medKind = ''; ST.medQuery = '';
      save(); render(); scrollTop();
    } else if (b.hasAttribute('data-med-scent')) {
      e.preventDefault();
      var sc = b.getAttribute('data-med-scent');
      ST.medScent = (ST.medScent === sc) ? '' : sc; save(); render();
    } else if (b.hasAttribute('data-med-kind')) {
      e.preventDefault();
      var kd = b.getAttribute('data-med-kind');
      ST.medKind = (ST.medKind === kd) ? '' : kd; save(); render();
    } else if (b.hasAttribute('data-media-open')) {
      e.preventDefault(); openLightbox(b.getAttribute('data-media-open'));
    } else if (b.hasAttribute('data-media-get')) {
      e.preventDefault(); downloadItem(b.getAttribute('data-media-get'), b);
    } else if (b.hasAttribute('data-media-copy')) {
      e.preventDefault();
      var mi = findItem(b.getAttribute('data-media-copy'));
      if (mi) toClipboard(mi.url, b);
    } else if (b.hasAttribute('data-med-copyall')) {
      e.preventDefault(); toClipboard(currentList(), b);
    } else if (b.hasAttribute('data-med-list')) {
      e.preventDefault(); saveList();
    } else if (b.hasAttribute('data-lb-close')) {
      e.preventDefault(); closeLightbox();
    } else if (b.hasAttribute('data-reset')) {
      e.preventDefault();
      if (w.confirm(t('ui.resetConfirm'))) {
        try { w.localStorage.removeItem(KEY); w.localStorage.removeItem(PENDING); } catch (err) {}
        ST = blank(); render(); scrollTop();
      }
    } else if (b.hasAttribute('data-print')) {
      e.preventDefault(); w.print();
    }
  });

  function flagMissing(keys) {
    var box = $('[data-missing]', app);
    keys.forEach(function (k) {
      var f = $('[data-field="' + k + '"]', app);
      if (!f) return;
      f.classList.add('is-invalid');
      var why = $('[data-ferr]', f);
      if (why) { why.textContent = REASON[k] || ''; why.hidden = !REASON[k]; }
    });
    if (box) { box.textContent = t('ui.missing', { n: keys.length }); box.hidden = false; }
    var first = $('[data-field="' + keys[0] + '"]', app);
    if (first) {
      first.scrollIntoView({ block: 'center', behavior: 'smooth' });
      var input = $('input,select,textarea', first);
      if (input) input.focus({ preventScroll: true });
    }
  }
  function scrollTop() { try { root.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { w.scrollTo(0, 0); } }

  d.addEventListener('click', function (e) {
    var lb = e.target.closest ? e.target.closest('[data-lb]') : null;
    if (!lb) return;
    var b = e.target.closest('button');
    if (!b) return;
    if (b.hasAttribute('data-media-get')) { e.preventDefault(); downloadItem(b.getAttribute('data-media-get'), b); }
    else if (b.hasAttribute('data-media-copy')) {
      e.preventDefault();
      var mi = findItem(b.getAttribute('data-media-copy'));
      if (mi) toClipboard(mi.url, b);
    }
  });

  /* live search, debounced, without losing the caret */
  var medTimer = null;
  root.addEventListener('input', function (e) {
    var i = e.target;
    if (!i.hasAttribute || !i.hasAttribute('data-med-q')) return;
    ST.medQuery = i.value;
    if (medTimer) clearTimeout(medTimer);
    medTimer = setTimeout(function () {
      var host = $('.pp-pp__mgrid', app), count = $('.pp-pp__medcount', app);
      var list = filteredMedia();
      if (host) host.innerHTML = list.map(tileHTML).join('');
      if (count) count.textContent = t('ui.med.count', { n: list.length });
      save();
    }, 160);
  });

  root.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.hasAttribute('data-gate')) {
      e.preventDefault();
      var input = $('input', f), err = $('[data-gate-err]', app);
      if (ACC.required && !ACC.signedIn) {
        if (err) { err.textContent = t('ui.gate.needAccount'); err.hidden = false; }
        return;
      }
      if (norm(input.value) === norm(CFG.gateCode)) {
        ST.stage = ST.submittedAt ? (ST.unlocked ? 'pack' : 'review') : 'apply';
        if (ST.confirmedAt) ST.stage = 'done';
        save(); render(); scrollTop();
        return;
      }
      var typed = input.value, sb = $('button[type=submit]', f), lbl = sb ? sb.textContent : '';
      if (sb) { sb.disabled = true; sb.textContent = t('ui.gate.working'); }
      unlockClient(typed).then(function (m) {
        if (m && m.slug) {
          ST.client = m; ST.spaceTab = 'home'; ST.stage = 'space'; ST.subLang = '';
          save(); render(); scrollTop();
          return;
        }
        if (sb) { sb.disabled = false; sb.textContent = lbl; }
        if (err) err.hidden = false;
        input.value = ''; input.focus();
      });
    } else if (f.hasAttribute('data-unlock')) {
      e.preventDefault();
      var i2 = $('input', f), e2 = $('[data-unlock-err]', app);
      if (norm(i2.value) === norm(CFG.approvalCode)) {
        ST.unlocked = true; ST.stage = 'pack';
        /* carry Stage 1 answers into the packing list so nothing is retyped */
        if (!ST.pack.pk_consignee) ST.pack.pk_consignee = ST.data.legal_name || '';
        if (!ST.pack.pk_address) ST.pack.pk_address = ST.data.ship_address || '';
        if (!ST.pack.pk_country) ST.pack.pk_country = ST.data.ship_country || '';
        if (!ST.pack.pk_incoterm) ST.pack.pk_incoterm = ST.data.incoterm || '';
        if (!ST.pack.pk_forwarder) ST.pack.pk_forwarder = [ST.data.forwarder, ST.data.forwarder_account].filter(Boolean).join(' — ');
        if (!ST.pack.pk_contact) ST.pack.pk_contact = ST.data.logi_name || ST.data.buyer_name || '';
        if (!ST.pack.pk_phone) ST.pack.pk_phone = ST.data.buyer_phone || '';
        save(); render(); scrollTop();
      } else if (e2) { e2.hidden = false; i2.value = ''; i2.focus(); }
    }
  });

  if (ST.client && ST.stage !== 'space' && ST.stage !== 'media') ST.stage = 'space';
  if (ST.client && w.location.hash === '#media' && MCFG.enabled) { ST.backStage = 'space'; ST.stage = 'media'; }
  render();
})(window, document);
